// (onRowInserted)="$event.component.navigateToRow($event.key)"

import { HttpClient, HttpParams } from "@angular/common/http";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    Type,
    ViewChild,
    ViewChildren,
    ViewContainerRef,
} from "@angular/core";
import {
    DxDataGridComponent,
    DxDropDownBoxComponent,
    DxFormComponent,
} from "devextreme-angular";
import CustomStore from "devextreme/data/custom_store";
import "jspdf-autotable";
import { environment } from "../../../environments/environment";
import {
    costantValue,
    FormsTemplateService,
} from "../../services/forms-template.service";
import { DetailComponent, _datiDetail } from "../detail/detail.component";
import { alert } from "devextreme/ui/dialog";
import { Apiservice } from "../../services/api.service";
import { AutoTablePDFConfig } from "../shared/anteprima-pdf/AutoTablePDFConfig";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import { ComponentService } from "../../services/component.service";
import { messagefromComponent } from "../../class/appinterface";
import { OverlaySideFormService } from "../shared/overlay-side-form/overlay-side-form.service";
import DataSource from "devextreme/data/data_source";
import { ActivatedRoute } from "@angular/router";
import { DocxExporterService } from "../../services/docx-exporter.service";
import { HttpBackend } from "@angular/common/http";
import { Utenteservice } from "../../services/utente.service";
import { NicaModelloStampaComponent } from "../../widgets/nica-modello-stampa/nica-modello-stampa.component";
import {
    IModelloStampa,
    ModelliStampaService,
} from "../../services/modelli-stampa.service";
import { NgxSpinnerService } from "ngx-spinner";
import { isArray } from "util";
import { Workbook } from "exceljs";
import dxDataGrid, { Column } from "devextreme/ui/data_grid";

/*
            location: 'after',
 widget: 'dxButton',
 options: {
         icon: 'tel',
         //onClick: function(){alert("ciao","ciao")} oppure this.test
              
         */
export interface arrObjetSelectedRow {
    flag: boolean;
    key: any;
    value: any;
}


export interface ToolbarButton {
    location: "before" | "center" | "after";
    widget?: string;
    cssClass?: string;
    isTemplateText?: boolean;
    name?: string;
    options: {
        icon: string;
        title: string;
        text: string;
        index?: number;
        id?: string;
        class?: string;
        stylingMode?: string;
        disabled?: boolean;
        visible?: boolean;
    };
}

var colonneInTemplate: any = [];
var Relazione: any;
var flagRelazione: any;
var relationRecord: any;
let masterThis: any;

@Component({
    selector: "nica-anagrafica",
    templateUrl: "./nica-anagrafica.component.html",
    styleUrls: [
        "./nica-anagrafica.component.css",
        "./nica-anagrafica.component.style.css",
        "./nica-anagrafica-template.css",
    ]
})
export class NicaAnagraficaComponent
    implements OnInit, OnChanges, AfterViewInit {
    [x: string]: any;

    @ViewChild("grigliaMaster", { static: false }) griglia: DxDataGridComponent;

    @ViewChild("formEdit", { static: true }) form: DxFormComponent;
    @ViewChild("masterDetailGrid", { static: true })
    masterDetailGrid: DetailComponent;
    @ViewChild("dynamicInsert", { static: false, read: ViewContainerRef })
    dynamicInsert: ViewContainerRef;
    @ViewChild("modelliStampaComp", { static: false })
    modelliStampaComp: NicaModelloStampaComponent;
    @ViewChild("dynamicInsertFormComponent", {
        static: false,
        read: ViewContainerRef,
    })
    dynamicInsertFormComponent: ViewContainerRef;
    @ViewChild("datagridModelliStampa", { static: false })
    datagridModelliStampa: DxDataGridComponent;

    @ViewChildren("name_lookup") name_lookup: QueryList<DxDropDownBoxComponent>;
    @ViewChildren("name_items") name_items: QueryList<any>;
    @ViewChildren("View_Items") View_Items: QueryList<any>;

    @ViewChildren(DxDropDownBoxComponent)
    alerts: QueryList<DxDropDownBoxComponent>;

    //@ViewChild(ExcelExporterComponent,{static:false}) excelExporter : ExcelExporterComponent;

    //@ViewChild('formEditingPopup',{static:false}) formEditingPopup : DxoPopupComponent;
    //grigliaB: DxDataGridComponent;
    //griglia: DxDataGridComponent;
    myDs: any = {};
    myOdata: any;
    modelliDiStampaDS: IModelloStampa[] = [];
    lookupCategoriaModelli: any[];
    relationRecord: any = [];
    arrObjetSelectedRows: arrObjetSelectedRow[] = [];

    /** URL Helper */
    @Input() columnAutoWidth = true;
    @Input() columnHidingEnabled = false;

    @Input() cssClassAddRowButton?: string = "";
    @Input() help?: string = "";
    @Input() selectRow: string = "single";
    @Input() showCheckBoxesMode: string = "none";
    @Input() api: string;
    @Input() service: string;
    @Input() isStatic: boolean = false;
    @Input() myDsStatic: any;
    @Input() isDataStatic: boolean = false;
    @Input() masterDati: any;
    @Input() codiceFunzione = "";
    @Input() rowAlternationEnabled = true;
    @Input() hoverStateEnabled: boolean = true;
    @Input() selectedKeys: any[];
    /** Tasto aggiunta nuova row personalizzato */
    @Input() customAddRowButton?: any;

    @Input() modifica = true; // edit e visualizzazione record
    @Input() elimina = true;
    @Input() aggiungi = true;
    @Input() update = true; // Visualizzazione e update record
    @Input() allowColumnResizing = false;
    @Input() prefix = null;


    @Input() cssClassToolBar = "";
    @Input() hideToolBar = "";
    @Input() titolo = "";
    @Input() classEvidenziaMaster = "";
    @Input() storage = false;
    @Input() classe: string;
    @Input() static: boolean = false;
    @Input() staticArray: any;
    @Input() TextAddRowButton: string = "Nuovo";
    @Input() focusedRowEnabled: boolean;
    /** Se false disabilita sia Search Panel sia Filter Row */
    @Input() ricerca: boolean = true;
    /** Se true è visibile solo la Search Panel e non la Filter Row */
    @Input() soloRicercaGlobale: boolean = false;
    @Input() location = "right";
    @Input() chiaviDettagli: _datiDetail[];
    @Input() apiDettagli: string[];
    @Input() filterDettagli: string[];
    @Input() name: string;
    @Input() editorType: string;
    @Input() dettagliCer: string = "";
    @Input() tagLoad: string = "";
    @Input() remoteOperations: boolean = false;
    @Input() dxoscrolling: string = "virtual";
    @Input() dxocolumnchooser: boolean = true;
    @Input() showColumnHeaders: boolean = true;
    @Input() showColumnLines: boolean = true;

    @Input() dxosorting: string = "";
    @Input() sommaGrouping: boolean = false; // se true esegue totale di gruppo se false totale di colonna
    @Input() titoloGriglia: string = "";
    @Input() Grouping: boolean = false;
    @Output() onRowSelect: EventEmitter<any> = new EventEmitter<any>();
    //@Output() onAfterLoad            :EventEmitter<any> = new EventEmitter<any>();

    //@Output() optionalButton         :EventEmitter<any> = new EventEmitter<any>();
    @Output() optionalButton = new EventEmitter<any>();
    // @Output() onAllEvent            :EventEmitter<any> = new EventEmitter<any>();
    @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() checkGetAll: EventEmitter<any> = new EventEmitter<any>(); // after getAll recors
    @Output() rowSelectionChanged = new EventEmitter<any>();
    @Output() optionalBottoneToolbar = new EventEmitter<any>();
    @Output() optionalBottoneNavigation = new EventEmitter<any>();
    // @Output() ValidateRow: EventEmitter<any> = new EventEmitter();
    //@Input() ValidateRow: (argument: () => any) => boolean;
    //: (argument: () => number) => void;
    //@Input() ValidateRow: EventEmitter< ((x:any) => boolean )>;

    @Input("beforeSaved") validaDati: (event: any) => any;
    @Input("beforeEdit") validateEdit: (event: any) => any;
    @Input("rowPrepared") validatePrepared: (event: any) => any;
    @Input("editorFieldPrepared") validateFieldPrepared: (event: any) => any;
    //@Input('onAfterLoad') ValidateLoad: (event:any) => any;
    @Input("onAfterLoad") ValidateLoad: Function;
    //@Output() onAfterLoad            :EventEmitter<any> = new EventEmitter<any>();

    @Input() pulsantiOpzionali: ToolbarButton[] = [];

    @Input() orientamento: "p" | "portrait" | "l" | "landscape";
    //@Input() formato: "a0" | "a1" | "a2" | "a3" | "a4" | "a5" | "a6" | "a7" | "a8" | "a9" | "a10";

    areRigheSelezionate: boolean = false;
    TabbedSelected;

    @Input() isExportPDFAvailable: boolean = true; //Esportazioni comuni
    @Input() isExportDocxAvailable: boolean = true;
    @Input() showResetFilterColumn: boolean = false;
    @Input() isExportExcelAvailable: boolean = true;

    /** Esporta Excel a partire dai DataTable oltre che di default dalla griglia */
    @Input() isAdvancedXlsExportAvailable: boolean = false;
    @Input() addFilterColumnToAdvancedXls: boolean = false;
    @Input() nascondiCelleRipetuteColonneOrdinate: boolean = false;
    // serve per aggiungere una nuova pagina al file Excel avanzato (prende le chiavi degli oggetti e crea gli header e i valori diventano le righe)
    @Input() advancedXlsExportAddWorksheet: Array<Record<string, any>> = [];
    @Input() advancedXlsExportAddWorksheetName?: string = 'Informazioni aggiuntive';
    @Input() customApiAdvancedXls?: string | null = null;

    /** Attiva i filtri avanzati (è richiesto un template apposito) */
    @Input() allowedAdvancedFilter: boolean;
    @Input() importSelectRow: boolean = false;

    @Input() defaultFormDisabled: boolean = false;

    /** Passando l'Id della Categoria Modelli di Stampa si abilita l'esportazione */
    @Input() idCategoriaModello?: string;
    stopPropagation: boolean = false;
    colonneDaEsportare: any[];
    pannelloEsportaExcelAdvanced: boolean = false;
    pannelloFiltriAvanzati: boolean = false;
    colonneOrdinateDaExporter?: string[];
    gridStateKey = "dxGridState";
    pippo = "pippo";
    selectedRows: number[] = [];
    @Input() showHeader: boolean = true;
    @Input() showFooter: boolean = true;
    @Input() onlyTitle: boolean = false;
    @Input() showRowLines: boolean = true;

    @Output() callbackFunction: EventEmitter<any> = new EventEmitter();

    //@Input('onAllEvent') onAllEvent: (event:any) => any;

    //editorFieldPrepared
    //@Input('optionalButton') optionalButtonClick: (event:any) => any;
    btnImportaRow = {
        name: "seleziona",
        icon: "mdi mdi-export",
        text: "",
        hint: "importa riga",
        onClick: async () => {
            alert("Fatto", "ff");
            //if(this.griglia)
            //await this.griglia.instance.saveEditData();
        },
    };

    salvaButtonOptions = {
        name: "salva",
        icon: "glyphicon icon-salva-form",
        text: "Salva",
        onClick: async () => {
            if (this.griglia) await this.griglia.instance.saveEditData();
        },
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: "text",
        event: "salva",
    };

    annullaButtonOptions = {
        name: "annulla",
        icon: "glyphicon glyphicon icon-annulla-form",
        text: "Annulla",
        onClick: () => {
            this.chiudiPopupEditing();
        },
        stylingMode: "text",
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        event: "annulla",
    };

    hiddenSubmitButtonOptions = {
        useSubmitBehavior: true,
        elementAttr: { style: "display:none", id: "hiddenBottoneSubmit" },
    };

    //optionalButton

    //rowPrepared
    @Input() showBorder: boolean = true;
    @Input() asDetail: _datiDetail;
    @Input() detailValue: any;
    @Input() filter: string = "";
    @Input() wingap: boolean = true;
    @Input() heightPopUpEdit: string;
    @Input() widthPopUpEdit: string;
    @Input() gridHeight: number = 300;
    @Input() gridWidth: number;
    @Input() paginate: boolean = false;
    @Input() pageSize: string = "100";
    @Input() shortKey: boolean = false;

    @Input() isPopupFullScreen: boolean = false;
    @Input() modeEdit:
        | "popup"
        | "batch"
        | "nicaform"
        | "customComponent"
        | "row"
        | "nicaforminternal" = "popup";
    @Input() modeEditComponent: Type<Component>;
    //masterKey
    @Input() masterKey: string = "id";
    @Input() costantValues: any; //Per insert e Update dei valori costanti da inviare via api ES.NomeTabella e versiones

    /** Specifica vi deve essere solo il Titolo su sfondo trasparente  */
    btnExportInstance: any;
    dataSetDesc: any[] = [];
    titoloPopUp: string;
    isEditing: boolean;
    isNewRecord: boolean;
    dropDownOptions: object;
    dsLookups: any[] = [];
    optionalDsLookup: any[] = [];
    customSourceP: any;
    dxitemOptions: any[] = [];
    buttonNavigation: any[] = [];
    formData: any;
    datiGriglia: any;
    configurationService: any;
    dxo_summary: any[];
    datiGrigliaD: any;
    datiGrigliaDd;
    colonneGriglia: any;
    colonneGrigliaTabella: any;
    colonnePerField: any;
    immagine: any[];
    items: any;
    _height: number;
    itemOptions: any;
    popupComponentTitle: string = "";
    popupEditVisible: boolean = false;
    mostraPopupModelliCaricati: boolean = false;
    countProg = -1;
    fnInstnce = {};
    myload;
    permessi = "";
    masterThis;
    mythis: any;
    versionCheck = {};
    versionValues: any[] = [];
    gridBoxValue: any[] = [];
    ciccio: DxDataGridComponent;
    dataRowSelected: any[]; //Dati riga nel popup
    editorTabDisabled: boolean[] = [];
    isonAfterLoadUsed: boolean = true; // se false alla prima load restituisce array vuoto
    myDSdisbleField: any[] = [];
    pannelloRaggruppamentoAperto: boolean = false;
    currentRow: any;
    currentKey: any;
    utenteConnesso;
    realClick = true;
    keyEspansa;
    dataDynamic: any[] = [];
    dataFieldForm: string = "";
    @HostListener("document:keydown", ["$event"])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key == "+" && this.shortKey) {
            if (!this.isNewRecord) {
                this.griglia.instance.addRow();
                //console.log("HostListener ", event);
                //console.log("Nuovo record ", this.isNewRecord);
            }
        }
    }
    constructor(
        public _overlaySideFormService: OverlaySideFormService,
        public _overlaySidePanelService: OverlaySideFormService,
        public _componentFactoryResolver: ComponentFactoryResolver,
        public spinner: NgxSpinnerService,
        public userComponentService: ComponentService,
        public appService: Apiservice,
        public http: HttpClient,
        public dati: FormsTemplateService,
        public cdref: ChangeDetectorRef,
        public componentFactoryResolver: ComponentFactoryResolver,
        public activatedroute: ActivatedRoute,
        public docxExporterService: DocxExporterService,
        public httpBackend: HttpBackend,
        public utenteSerivce: Utenteservice,
        public modelliStampaService: ModelliStampaService
    ) {
        this.name_lookup = null;
        this.valueChangedList = this.valueChangedList.bind(this);
        this.onCustomizeColumns = this.onCustomizeColumns.bind(this);

        //this.setStateValueLook = this.setStateValueLook2.bind(this); // va eliminato ???
        // this.setStateValueLook = this.setStateValueLook.bind(this); // va eliminato ???

        this.utenteConnesso =
            this.utenteSerivce.InfoDatiUtenteConnesso.userName;

        this.customSourceP = new CustomStore({
            loadMode: "raw",
            key: "id",
            load: (loadOptions: any) => {
                //************************************************************************ */
                let params: HttpParams = new HttpParams();
                [
                    "skip",
                    "take",
                    "requireTotalCount",
                    "requireGroupCount",
                    "sort",
                    "filter",
                    "totalSummary",
                    "group",
                    "groupSummary",
                    "TipoOperazione",
                ].forEach((i) => {
                    if (i in loadOptions && this.isNotEmpty(loadOptions[i])) {
                        let cVal = JSON.stringify(loadOptions[i]);
                        cVal = cVal.replace(/"/g, "");
                        params = params.set(i, cVal);
                    }
                });
                return this.http
                    .get("http://rentrincloud.it:8080/api/tipoImballo", {
                        params,
                    })
                    .toPromise()
                    .then((res) => {
                        if (res["items"]) {
                            res = res["items"];
                        } else {
                            res = res;
                        }
                        return res;
                    });
            },
        });

        this.mythis = this;
        //
        ////////console.log("ecco this in construct ",this.mythis);
    }
    someData: any = [{ name: "one" }, { name: "two" }];

    isNotEmpty(value: any): boolean {
        return value !== undefined && value !== null && value !== "";
    }
    checkPermessi(strPermessi) {
        const tipoUtente = this.utenteSerivce.DammiTipoUtente();

        //I permessi vengono considerati solo per utenti advanced/standard
        if (tipoUtente != 4 && tipoUtente != 5) return;

        //'CIMVS'
        //console.log("Sono in check ",strPermessi)
        if (this.aggiungi == true)
            this.aggiungi = strPermessi.indexOf("I") > -1 ? true : false;
        // sarebbe Edit
        if (this.modifica == true)
            this.modifica = strPermessi.indexOf("M") > -1 ? true : false;
        if (this.update == true)
            this.update = strPermessi.indexOf("M") > -1 ? true : false;
        if (this.elimina == true)
            this.elimina = strPermessi.indexOf("C") > -1 ? true : false;

        //this.elimina = false;
    }
    onRowInserting(e) {
        //let e=null;
        //event.cancel=true;

        //return;
        e.name = "onRowInserting";
        e = this.onAllEvent.emit(e);
        //if(e) event=e;
    }
    // reset state griglia
    onStateResetClick() {
        this.grigliaMaster.state(null);
    }
    onEditCanceling(event) {
        event.name = "onEditCanceling";
        event.componentName = this.name;
        this.onAllEvent.emit(event);
    }
    onOptionChanged(event) {
        event.componentName = this.name;
        this.onAllEvent.emit(event);
    }
    onEditCanceled(event) {
        event.name = "onEditCanceled";
        event.componentName = this.name;
        this.onAllEvent.emit(event);
        this.isNewRecord = false;
        this.isEditing = false;
    }

    onRowClickLookUp(event, cellInfo) {
        //return;
        /*let e={
        name : "onSelectionChangedLook",
     
        value : cellInfo.value,
        masterThis :this,
 
    };
    this.onAllEvent.emit(e);
*/
        (event.dataField = cellInfo.column.dataField),
            (event.name = "onRowClickLookUp");
        event.rowData = event.data;
        event.masterThis = this;
        event.value = cellInfo.value;
        event.component = cellInfo.component;
        event.cellInfo = cellInfo;
        this.onAllEvent.emit(event);
        //console.log("ffffffffffffffffffffff lookup ",event.data)
        //console.log("ffffffffffffffffffffff lookup ",cellInfo)
    }

    onSelectionChanged(event: any): void {
        this.selectedRows = event.selectedRowKeys;
        const checkRows: boolean = this.selectedRows.length > 0 ? false : true;
        this.disableCustomButton("modifica-percentuali", checkRows);
        this.rowSelectionChanged.emit(event);
    }

    onRowInserted(event) {
        event.name = "onRowInserted";
        event.componentName = this.name;
        this.onAllEvent.emit(event);
    }

    isCloneIconVisible = (e: any) => {
        return true;
        //return !e.row.isEditing;
        //this.cloneIconClick = this.cloneIconClick.bind(this);
    };

    getVisibleColumns() {
        //console.log(this.griglia.instance.getVisibleColumns());
    }
    getColumnsFromState() {
        //console.log(this.griglia.instance.state().columns);
    }
    getColumnsByOption() {
        //console.log(this.griglia.instance.option("columns"));
    }

    IconTextClick = (e: any, name: any, campo) => {
        e.name = name;
        console.log("Innnnnnnnnnnnnnnnnnnnnnnn ", e.name);
        if (this.myDSdisbleField[campo.prog] == true) return;
        //alert(campo.prog,'IconTextClick')
        if (e.name.includes("_clear")) {
            if (campo.autoClear) {
                this.settaField(campo.dataField, "");
                this.settaHelp(campo.dataField, "");
                return;
            }
        }
        let rows = this.griglia.instance.getVisibleRows();
        rows.forEach((row) => {
            if (row.isSelected || row.isEditing || row.isNewRow) {
                e.row = {};
                e.row.data = row.data; //rd[0];
                e.id = row.data[this.masterKey]; //   rd[0][this.masterKey];
                this.mythis.optionalButton.emit(e, campo);
                return;
            }
        });
        //let rd=this.griglia.instance.getSelectedRowsData();
        ////////console.log("wwwwwwwwwwwwwwwwwwww",rd);
        //this.selezionaRiga(rd[0]);
    };

    OptionalIconButtonClick = (e: any) => {
        console.log("eeeeeeeeeeeeeeeeqQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ ", e);
        this.selezionaRiga(e.row.data[this.masterKey]);
        //this.optionalButton.emit(e);
        if (e.column.buttons[0].name == "unitalocali") {
            e.name = e.column.buttons[0].name;
            e.componentName = this.name;
            this.optionalButton.emit(e);
            return;
        } else {
            e.name = e.column.buttons[0].name;
            e.componentName = this.name;
            this.mythis.optionalButton.emit(e);
            return;
        }
    };

    onkeyUp(w: any) {
        ////console.log("ONKEYUP ",w)
    }

    // evento richiamato da dxnumber
    onKeyDown(w: any) {
        return;
        w.name = "onKeyDown";
        //digit decimal
        /*let myFormat="#####.##";
    let myFormatArr=myFormat.split('.');    
    let digit=myFormatArr[0].length || 0;
    let decimal=myFormatArr[1].length || 0;
    */
        let digit = 0;
        let decimal = 0;
        let valorex = 0;
        let field = "";

        if (w.event.keyCode > 122) return;
        let keyCodeEsculi = [8, 46, 37, 39, 38, 40, 9];
        if (keyCodeEsculi.includes(w.event.keyCode)) return;

        // w.event.preventDefault();

        //console.log("Premuto INTERO ",w)
        //console.log("valore Attuale "+w.event.srcElement.ariaValueNow+'A',"Premuto intero")
        let rr1 = Object.entries(w.event.target.attributes);
        for (let t = 0; t < rr1.length; t++) {
            if (rr1[t][1]["name"] == "digit") {
                digit = rr1[t][1]["value"];
            }
            if (rr1[t][1]["name"] == "decimal") {
                decimal = rr1[t][1]["value"];
            }
            if (rr1[t][1]["name"] == "aria-valuenow") {
                valorex = rr1[t][1]["value"];
                //console.log("Il valre è "+valorex)
            }
            if (rr1[t][1]["name"] == "field") {
                field = rr1[t][1]["value"];
                //console.log("Il Campo è "+field)
            }
        }
        //console.log("decimal=",decimal)

        valorex = valorex + w.event.key;
        if (valorex > 99) {
            w.event.key = null;
            w.event.preventDefault();
        }
        return;

        //w.event.preventDefault();
        /* 
    if(Math.floor(value) === value) return 0;
            return value.toString().split(".")[1].length || 0; 
                             {            
                            w.event.key=null
                            w.event.preventDefault();
                        } 
  
    */

        //return w;
    }
    logEvent(e, name = null) {
        //////console.log(this.datiGriglia);
        const event = Object.assign(e, {name})
        this.onAllEvent.emit(name !== null ? event : e);

        this.dataRowSelected = [];
    }
    SelectionChanged(event: any) {
        let keyS = "";
        console.log("Selection changed ", event, this.selectedKeys);
        event.selectedKeys = this.selectedKeys;
        let arrIndex = [];
        let arrM1 = [];
        for (let i = 0; i < this.arrObjetSelectedRows.length; i++) {
            this.arrObjetSelectedRows[i].flag = false;
        }
        if (this.selectedKeys && this.selectedKeys.length)
            for (let i = 0; i < this.selectedKeys.length; i++) {
                let idx = this.griglia.instance.getRowIndexByKey(
                    this.selectedKeys[i]
                );
                if (idx == -1) {
                    // probabilmente era selezionato prima
                    this.keyS = this.selectedKeys[i];
                    let exist = this.arrObjetSelectedRows.findIndex(
                        (x) => x.key == this.keyS
                    );
                    if (exist > -1) {
                        this.arrObjetSelectedRows[exist].flag = true;
                    }
                } else {
                    this.keyS = this.selectedKeys[i];
                    let exist = this.arrObjetSelectedRows.findIndex(
                        (x) => x.key == this.keyS
                    );
                    if (exist > -1) {
                        this.arrObjetSelectedRows[exist].flag = true;
                    } else {
                        let rows = this.griglia.instance.getVisibleRows();
                        let rowIndex = this.griglia.instance.getRowIndexByKey(
                            this.keyS
                        );
                        let row = rows[rowIndex];
                        console.log("ECCO I DATA ", row);

                        let m1 = {
                            flag: true,
                            key: this.selectedKeys[i],
                            //value:this.griglia.instance.getRowIndexByKey(this.selectedKeys[i],
                            //value:this.griglia.instance.getRowIndexByKey(this.selectedKeys[i])
                            value: row.data[this.masterKey],

                            //value:event.dataIndex
                        };
                        this.arrObjetSelectedRows.push(m1);
                    }
                }
                //cerco Key
                /*this.keyS=this.selectedKeys[i]   
         let exist=this.arrObjetSelectedRows.findIndex(x=>x.key==this.keyS)
         if(exist>-1){
             this.arrObjetSelectedRows[exist].flag=true
         }
         else{
             let m1={flag:true,key:this.selectedKeys[i],value:this.griglia.instance.getRowIndexByKey(this.selectedKeys[i])}      
         }*/
                /*let m1={flag:true,key:this.selectedKeys[i],index:this.griglia.instance.getRowIndexByKey(this.selectedKeys[i])}
         this.arrObjetSelectedRows.push(m1);
         arrIndex.push(this.griglia.instance.getRowIndexByKey(this.selectedKeys[i]))
         console.log(this.griglia.instance.getRowIndexByKey(this.selectedKeys[i]))
         */
            }
        //let arrIndexOrdinato=arrIndex.sort((a, b) => a - b)
        const result = this.arrObjetSelectedRows.filter((x) => x.flag == true);
        this.arrObjetSelectedRows = result;

        for (let x = 0; x < this.arrObjetSelectedRows.length - 1; x++)
            for (let y = x + 1; y < this.arrObjetSelectedRows.length; y++) {
                if (
                    this.arrObjetSelectedRows[x].value >
                    this.arrObjetSelectedRows[y].value
                ) {
                    let comod = this.arrObjetSelectedRows[x];
                    this.arrObjetSelectedRows[x] = this.arrObjetSelectedRows[y];
                    this.arrObjetSelectedRows[y] = comod;
                }
            }

        console.log("arrObjetSelectedRows ", this.arrObjetSelectedRows);
        /*
     let keys = e.component.getSelectedRowKeys();  
        let index = keys.indexOf(e.key);  
  
        if (index > -1) {  
            keys.splice(index, 1);  
        } else {  
            keys.push(e.key);  
        }  
  
        e.component.selectRows(keys);  
  
    */

        //////console.log(event)
        event.name = "onSelectionChanged";
        // ////////console.log("LLLLLLLLLLLLLLLLLLLLLLLLL ",event.data)
        event.componentName = this.name;
        event.arrObjetSelectedRows = this.arrObjetSelectedRows;
        this.onAllEvent.emit(event);
        //this.onRowSelect.emit(event.data);
        this.onRowSelect.emit(event.data);
        // ////////console.log("evento ",event.selectedRowsData[0]);
        const selectedRowsData = this.griglia.instance.getSelectedRowsData();
        this.rowSelectionChanged.emit(selectedRowsData);
    }

    public aggiornaEditing(e: any) {
        //cellValue(rowIndex, dataField, value)
        let rowInEdit;
        let rows = this.griglia.instance.getVisibleRows();
        let Index = -1;
        rows.forEach((row) => {
            Index++;
            if (row.isSelected || row.isEditing || row.isNewRow) {
                // row.data.partitaIVA='Modificaa'
                rowInEdit = row;

                for (let key in e) {
                    this.griglia.instance.cellValue(Index, key, e[key]);
                }
                ////////console.log("Form Aggiornata ",rowInEdit)
            }
        });
    }

    campoDesc(e, r, k) {
        //console.log(e);
        //console.log(r);
        //console.log(k);
        //console.log(this.currentRow)

        alert("wwww", "wwwww");
    }
    public Agg() {
        this.griglia.instance.cellValue(0, "Descrizione", "ddd");
        this.griglia.instance.saveEditData();
    }

    public settaHelp(field: string, value: any) {
        // console.log(this.View_Items);
        //registroRentri2
        return;
        this.settaField("registroRentri2", value);
        return;
        //this.colonnePerField[field].helpText=value;
        //return;

        let elements = [];
        this.colonneGriglia.forEach((element, i) => {
            if (element.dataField == field) {
                element.helpText = value;
            }
        });
    }

    public settaField(field: any, value: any) {
        //this.spinner.show();
        setTimeout(() => {
            var objActual =
                this.mythis.griglia.instance.getController("editing");
            //var actualData = objActual._dataController._items[0]['data'];
            //objActual._dataController._items[0]['data'][field] = value //OK
            let xx = {
                [field]: value,
            };
            objActual._dataController._changes.push(xx);

            let rows = this.griglia.instance.getVisibleRows();
            //let Index =this.griglia.instance.getRowIndexByKey(this.currentRow.id);
            //this.stopPropagation=true;
            //this.griglia.instance.cellValue(Index,field, value)
            //this.stopPropagation=false;
            //return;
            this.stopPropagation = true;
            //let xx=this.griglia.instance.getRowIndexByKey(this.currentKey);
            //this.griglia.instance.cellValue(xx,field, value);

            //return;

            for (let x = 0; x < rows.length; x++) {
                if (
                    rows[x].isSelected ||
                    rows[x].isEditing ||
                    rows[x].isNewRow
                ) {
                    if (!Array.isArray(field))
                        this.griglia.instance.cellValue(x, field, value);
                    else {
                        field.forEach((fd) => {
                            this.griglia.instance.cellValue(x, fd, value);
                        });
                    }
                    this.stopPropagation = false;
                    this.spinner.hide();
                    break;
                }
            }
        }, 150);

        //-------------------------------------------------
        let founds = this.returnDynamicComponent();
        this.currentRow = {};
        if (founds > "") this.instanceComponent(founds);

        //--------------------------------------------------

        //-------------------------------------------------
        /*   let founds = this.returnDynamicComponent();
         this.currentRow={};
         if (founds > '') this.instanceComponent(founds);
 */
        //--------------------------------------------------
    }

    public refreshDs(prg: any, value: any, filter?: string) {
        if (this.colonneGriglia[prg].lista) {
            if (this.colonneGriglia[prg].lista.Async) {
                const ds = this.colonneGriglia[prg].lista.dataSource;
                //console.log("ECCO LA COLONNA IN REFRESH DS")
                this.dsLookups[prg] = {
                    store: new CustomStore({
                        loadMode: "raw",
                        load: () =>
                            this.dati.getDatiAsync(ds, value).then((res) => {
                                return res;
                            }),
                    }),
                };
            }
            if (this.colonneGriglia[prg].lista.static) {
                const ds = this.colonneGriglia[prg].lista.dataSource;
                this.dsLookups[prg] = {
                    store: new CustomStore({
                        loadMode: "raw",
                        load: () => this.dati.getDati(ds, value),
                    }),
                };
            }
        } // end lista
        //pippa
        if (this.colonneGriglia[prg].lookup) {
            if (this.colonneGriglia[prg].lookup.static) {
                const ds = this.colonneGriglia[prg].lookup.dataSource;
                this.dsLookups[prg] = {
                    store: new CustomStore({
                        loadMode: "raw",
                        load: () => this.dati.getDati(ds, value),
                    }),
                };
            } else {
                //let gg=colonna.related[0].filter_relation;
                //xx={[gg]:cellInfo.value}
                let xx = JSON.parse(value); // {field:value}
                //console.log(" ecco xx", xx)

                this.dsLookups[prg]._loadFunc(xx).then((pp) => {
                    this.dsLookups[prg].__rawData = pp;
                    //console.log("IN REFRSH ", pp, xx)
                    //rowData[colonna.lookup.related[0].dataField] = null
                });

                this.dsLookups[prg].load(xx).then((pp) => {
                    this.dsLookups[prg].__rawData = pp;

                    //console.log("TTTTTTTTTTTTTTTTTTTT ", pp, this.dsLookups[prg])
                });
            }
        }
    }

    public returnElementsInGriglia(fields: any = []) {
        let elements = [];
        this.colonneGriglia.forEach((element, i) => {
            if (element.dataField) {
                const found = fields.find((elementX) => {
                    return (
                        elementX.toLowerCase() ===
                        element.dataField.toLowerCase()
                    );
                });
                if (found !== undefined) {
                    elements.push(element);
                }
            }
        });
        return elements;
    }
    public returnDynamicComponent() {
        let tr = -1;

        for (let j = 0; j < this.colonneGriglia.length; j++) {
            let element = this.colonneGriglia[j];

            //this.colonneGriglia.forEach((element, i) => {
            if (element.type == "component") {
                return this.colonneGriglia[j].component;
            }
        }
        /*)

    if (tr > -1) {
        //return this.colonneGriglia[tr].dataField
        return this.colonneGriglia[tr].component
    }*/
        return "";
    }

    public refreshAllRelation(data: any) {
        let tr = -1;
        let AllRelated = [];
        this.colonneGriglia.forEach((element, i) => {
            if (element.lookup && element.lookup.related) {
                let relatedColumn = this.returnElementsInGriglia([
                    element.lookup.related[0].dataField,
                ])[0];
                this.UpdateDSInitizialed(
                    element,
                    relatedColumn,
                    data[element.dataField],
                    data
                );

                ///
            }
        });
    }

    public returnRelation(field: string) {
        let tr = -1;
        this.colonneGriglia.forEach((element, i) => {
            if (element.dataField && element.dataField == field) {
                if (element.lookup && element.lookup.related) {
                    tr = i;
                }
            }
        });
        if (tr > -1) {
            return this.colonneGriglia[tr].lookup; //.related
        }
        //return null;
    }
    customizeItem(item) {
        //console.log("CUSOMIZEEEEEEEEEEEEEEEEE ",item)
        //console.log("CUSOMIZEEEEEEEEEEEEEEEEE this",this)
        let editRowKey = this.griglia.instance.option("editing.editRowKey");
        let index = this.griglia.instance.getRowIndexByKey(editRowKey);
        index = index === -1 ? 0 : index;
        //item.visible =this.griglia.instance.cellValue(index, "RPADependant");
        //item.visible=false;
    }

    public changeStateField(fields: any = [], value: boolean) {
        //return;
        this.colonneGriglia.forEach((element, i) => {
            if (element.dataField) {
                const found = fields.find((elementX) => {
                    return (
                        elementX.toLowerCase() ===
                        element.dataField.toLowerCase()
                    );
                });
                if (found !== undefined) {
                    this.myDSdisbleField[element.prog] = value;
                }
            }
        });
    }
    public refresh() {
        if (this.griglia) this.griglia.instance.refresh();
    }

    public selezionaRiga(id: any) {
        if (this.griglia) {
            this.griglia.instance.selectRows(id, false);
            //alert("seeeeeeeeeeeeeeeeeeeeeeeeeeeee","wwwwwwwwwwwwwwwwwwww")
        }
    }
    nascondiElementiRowByClasse(classe: string, rowIndex: number): void {
        const rowElement = this.griglia.instance.getRowElement(rowIndex) as HTMLElement[]
        if (!rowElement || rowElement.length === 0) {
            return
        }
        const elementi = rowElement[0].querySelectorAll<HTMLElement>(`.${classe}`);

        if (!elementi || elementi.length === 0) {
            return;
        }
        elementi.forEach(el => {
            el.style.display = 'none';
        });

    }


    messaggioFromComponent(message: messagefromComponent) {
        if (this.name == undefined) {
            return;
        }
        if (message && message.destComponent == this.name) {
            if (message.traceMessage == "refresh") {
                if (this.griglia) {
                    this.griglia.instance.cancelEditData();
                    this.griglia.instance.refresh();
                }
            }
            if (message.traceMessage == "isOverlay") {
                this.onlyTitle = true;
            }
        }
    }
    setStateValue = (rowData: any, value: any) => {
        ////////console.log("Cambio lookup rowdata",rowData);
        ////////console.log("Cambio lookup value",value);
        //  (<any> this).defaultSetCellValue(rowData, value);
        // [setCellValue]="setStateValue"
        /*let e={
        name:"ChangedValueLookUp",
        value:value
    }*/
        //e.name="ChangedValueLookUp"
        //this.onAllEvent.emit(e);
    };

    valueChangedList(this: any, owData: any, value: any, currentRowData: any) {
        //console.log("this ",this);
        //console.log("owData ",owData);
        console.log("value ", value);
        //console.log("currentRowData ",currentRowData);

        let event = {
            data: owData,
            value: value,
            name: "valueChangedList",
        };
        //alert("SSSSSSSSSSSSSSSSS", "WWWWWWWWWWWWWWWWWWWW");
        this.onAllEvent.emit(event);
        //////console.log("valueChangedListpppppppppppppppppppppppppppp",event);
    }

    valueChangedLookUp(event: any, cellinfo: any) {
        //console.log("valueChangedLookUpppppppppppppppppppppppppppppppp",event,cellinfo);
        //if(event.value==undefined)
        //cellinfo.setValue(null);
        cellinfo.setValue(event.value);
        //alert("wwwwwwwwwwwwwwww",'wwwwwwwwwwwwwwww')
    }
    onSavedLook(event: any, component: any, i: any) {
        //console.log("OnSaved ", event);
        //console.log("OnSaved ", component);
    }
    onEditingStartLook(e: any) {
        e.name = "onEditingStart";
        e.componentName = this.name;
        e.masterThis = this;
        ////console.log("ffffffffffffffffffffffv ",e)
        this.onAllEvent.emit(e);
        //////console.log("Raised before a row is editing ",e);
    }
    onRowInsertedLook(e: any) { }
    //Raised before a row is updated in the data source.
    onRowUpdatingLook(e: any) {
        //values['version']=this.versionValue[prog];
        //////console.log("Raised before a row is updated in the data source ",e);
    }
    //Raised after a row has been updated in the data source.
    onRowUpdatedLook(e: any) { }
    onRowInsertingLook(event: any, component: any, k: any) {
        //////console.log("On Saving ",event);
        //event.changes[0].data.nomeTabella="sedi";
    }
    onInitNewRowLook(event: any, component: any, k: any) {
        //alert("dddddd","wwwwww");
        //////console.log("INSERISCOOOOOOOOOOOOO ",event);
        //event.setValue(event.row.data.nomeTabella+"sedi")
    }
    onSavingLook(event: any, component: any, k: any) {
        //console.log("onSavingLook ", event);
        //console.log("onSavingLook ", component);
        //component.refresh(true);
    }
    onEditorPreparedLook(event: any) {
        //////console.log("In Prepared ",event);
    }
    editClickLook(e: any, k) {
        //// ////////console.log("editClickLook ",e);
    }
    onEditorPreparingLook(
        event: any,
        component: any,
        k: any,
        colonnaLookUp: any
    ) {
        if (event.row) {
            if (event.row.data.versione) {
                event.setValue(
                    event.row.data.versione + "",
                    event.row.data.versione + ""
                );
                this.versionValues[k]["versione"] = event.row.data.versione;
            }
        }
        event.name = "onEditorPreparing";
        this.onAllEvent.emit(event);
        return;
        if (event.dataField == colonnaLookUp.valueExpr) {
        }

        if (event.row) {
            //parentType: "dataRow"
            //this.versionValues[k]['version']=event.row.data.version;
            if (event.row.data.versione) {
                event.setValue(
                    event.row.data.versione + "",
                    event.row.data.versione + ""
                );
                this.versionValues[k]["versione"] = event.row.data.versione;
                this.versionValues[k]["nomeTabella"] =
                    event.row.data.nomeTabella;
            }
            if (event.row.data.nomeTabella) {
                alert("settata tabella", "Pippo");
                event.setValue(
                    event.row.data.nomeTabella + "",
                    event.row.data.nomeTabella + ""
                );
            }

            if (event.row.data.versione) {
                //this.versionValues[k]['version']=event.row.data.version;
                //////console.log("onEditorPreparedLook ",event);
                if (event.dataField == "versione") {
                    event.setValue(
                        event.row.data.versione + "",
                        event.row.data.versione + ""
                    );
                }
                if (event.dataField == "nomeTabella") {
                    event.setValue(
                        event.row.data.nomeTabella + "",
                        event.row.data.nomeTabella + ""
                    );
                }
            }
            if (event.row.data.nomeTabella) {
                //this.versionValues[k]['nomeTabella']=event.row.data.nomeTabella;
                if (event.dataField == "nomeTabella") {
                    event.setValue(
                        event.row.data.nomeTabella + "",
                        event.row.data.nomeTabella + ""
                    );
                }
            }
        }
    }

    ngOnInit() {
        //console.log('chiaviDettagli',this.chiaviDettagli)
        // alert(this.storage+"",'wwwwwwwwww')

        this.mythis = this;
        //this.isonAfterLoadlUsed = this.onAfterLoad.observers.length > 0;

        let servletAnswer1 =
            '<script type="text/javascript">function eseguiFunzione(query){alert(query,"title");}</script>';
        $("body").append(servletAnswer1);

        let servletAnswer =
            '<script type="text/javascript">function findTemplate() {return colonneInTemplate;}</script>';
        $("body").append(servletAnswer);
        servletAnswer =
            '<script type="text/javascript">function settaTemplate(col) {colonneInTemplate=col;}</script>';
        $("body").append(servletAnswer);
        servletAnswer =
            '<script type="text/javascript">function settaRelation(rel) {Relazione=rel;}</script>';
        $("body").append(servletAnswer);
        servletAnswer =
            '<script type="text/javascript">function findRelation(){ if (typeof Relazione !== "undefined") return Relazione;else return "";}</script>';
        $("body").append(servletAnswer);
        servletAnswer =
            '<script type="text/javascript">function settaThis(value) {masterThis=value;}</script>';
        $("body").append(servletAnswer);
        servletAnswer =
            '<script type="text/javascript">function findmasterThis() {return masterThis;}</script>';
        $("body").append(servletAnswer);
        servletAnswer =
            '<script type="text/javascript">function MyButtonClik() {alert("ho clikkato");}</script>';
        $("body").append(servletAnswer);

        eval("settaThis(this.mythis)");

        //this.isonAfterLoadlUsed = (typeof this.validaDati == 'function') ? true : false

        this.OptionalIconButtonClick = this.OptionalIconButtonClick.bind(this);
        this.customizeItem = this.customizeItem.bind(this);
        this.IconTextClick = this.IconTextClick.bind(this);

        this.itemOptions = {
            icon: "more",
            onClick: ($event) => {
                this.IconTextClick($event, 1, null);
            },
        };

        //this.griglia=ViewChild('grigliaMaster'+this.name, { static: true })

        this.userComponentService.castMessage.subscribe(
            (message: messagefromComponent) =>
                this.messaggioFromComponent(message)
        );
        let masterThis2 = this;
        this.masterThis = this;
        if (this.service == "" || this.service == undefined) {
            this.service = this.api;
            //////console.log(this.api);
        }
        this.dropDownOptions = { width: 500 };
        //alert(this.service);
        if (this.gridHeight > 0) {
            // ! RIMOSSO PERCHE SOVRASCIVE TUTTE LE DIVERSE INSTANZE DI UNA VISTA ALL'ULTIMA CARICATA
            /* let elementGrid = null;
            if (this.name) {
                 let xx = this.name.replace(/[ ]/g, '');
                 elementGrid = $('#grigliaMaster [name=' + xx + ']');
            }
            if (elementGrid) {
                 $(elementGrid).height(this.gridHeight + 'px');
                 $(elementGrid).css('height', this.gridHeight + 'px');
            } else {
                 $('#grigliaMaster').height(this.gridHeight + 'px');
                 $('#grigliaMaster').css('height', this.gridHeight + 'px');
            } */
        }
        if (this.gridWidth > 0) {
            //$("#grigliaMaster").width("99%");
        }
        const that = this;

        if (this.codiceFunzione.length > 0) {
            //console.log("Ecco ipermessi", this.utenteSerivce.DammiPermessiFunzione(this.codiceFunzione))
            this.permessi = this.utenteSerivce.DammiPermessiFunzione(
                this.codiceFunzione
            );
            this.checkPermessi(this.permessi);
        } else {
            this.activatedroute.queryParams.subscribe((params) => {
                //console.log("Parametri in Nica Anagrafica 1 =",params);

                //console.log(params)

                if (params && params.currentTabId) {
                    setTimeout(() => {
                        let permessiUtenteGruppoFunzione =
                            this.utenteSerivce.DammiPermessiFunzione(
                                params.currentTabId
                            );

                        //console.log("PERMESSI:",params.currentTabId, permessiUtenteGruppoFunzione)

                        this.checkPermessi(permessiUtenteGruppoFunzione);
                    }, 2000);
                } else {
                }
                //this.currentTabId=this.params.currentTabId;
            });
            //}
        }

        /*
        this.aggiungi
        this.modifica
        this.elimina

    */

        let prog = -1;
        if (this.service) this.datiGriglia = this.dati.getService(this.service);
        //////console.log("Dati Griglia Service ",this.datiGriglia)
        console.log("Dati Griglia Service ", this.datiGriglia);
        this.colonneGriglia = [];
        this.colonneGrigliaTabella = [];
        this.colonnePerField = [];
        this.myDSdisbleField = [];
        this.dxo_summary = [];
        //-----------------------------------
        ////////console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww")
        //-----------------------------------

        if (this.datiGriglia != undefined) {
            let servletAnswer =
                '<script type="text/javascript">function !function(rowData){rowData.dataField = null;}</script>"';

            let datiGriglia = this.datiGriglia.filter(
                (res) =>
                    res.itemType != null || typeof res.itemType != "undefined"
            );
            this.configurationService = this.datiGriglia.filter(
                (r) => r.configuration
            );

            this.datiGriglia = datiGriglia;
            this.datiGriglia.forEach((element, i) => {
                console.log();
                if (element.componentType) {
                    this.editorTabDisabled[element.componentType] = true;
                }

                if (element["itemType"] != "")
                    if (element["data"])
                        element["data"].forEach((campo, j) => {
                            if (campo.dxoSummary) {
                                this.dxo_summary.push({
                                    column: campo.dataField,
                                    summaryType: campo.dxoSummary.summaryType,
                                    showInGroupFooter:
                                        campo.dxoSummary.showInGroupFooter,
                                    valueFormat: campo.dxoSummary.valueFormat,
                                    displayFormat:
                                        campo.dxoSummary.displayFormat,
                                    alignByColumn:
                                        campo.dxoSummary.alignByColumn,
                                    alignment: campo.dxoSummary.alignment,
                                });
                            }

                            if (campo.tipoTotaleXX) {
                                this.dxo_summary.push({
                                    column: campo.dataField,
                                    tipo: campo.tipoTotale,
                                    showInGroupFooter: true,
                                });
                            }
                            if (campo.lookup)
                                if (campo.lookup.related) {
                                    servletAnswer = servletAnswer.replace(
                                        /!function/g,
                                        campo.lookup.related[0].dataField
                                    );
                                    servletAnswer = servletAnswer.replace(
                                        /dataField/g,
                                        campo.lookup.related[0].dataField
                                    );
                                    //console.log("campoooooooooooo ", campo.lookup);
                                    //console.log("function  ", servletAnswer);
                                    $("body").append(servletAnswer);
                                    //idOperazione
                                }

                            // ////////console.log("Dati Griglia ",campo.dataField)
                            prog++;
                            campo["prog"] = prog;
                            campo["disabledRunTime"] = false;
                            this.myDSdisbleField[prog] = false;
                            this.colonneGriglia.push(campo);

                            //ZORRO
                            this.versionCheck = {
                                key: "",
                                values: "",
                            };
                            this.versionValues.push(this.versionCheck);

                            //this.versionValues[prog]['version']="";
                            //this.versionValues[prog]['nomeTabella']="";
                            //dxitemOptions
                            ////////console.log("PROG ",prog,campo.dataField);
                            if (campo.type == "campoDesc") {
                                this.dataSetDesc[campo.dataField] = "";
                            }
                            if (campo.type == "campoDescInfo") {
                                // this.dataSetDesc[campo.dataField]='';
                            }
                            if (campo.type == "component") {
                                this.instanceComponent(campo.component);
                            }
                            if (campo.type == "campoIconMultiple") {
                                campo["button"]["index"] = prog;
                                this.dxitemOptions[prog] = [
                                    {
                                        icon: campo.button.icon,
                                        name: campo.button.name,
                                        onClick: ($event) => {
                                            this.IconTextClick(
                                                $event,
                                                campo.button.name,
                                                campo
                                            );
                                        },
                                    },
                                ];
                            }
                            if (campo.type == "campoIcon") {
                                campo["button"]["index"] = prog;
                                this.dxitemOptions[prog] = [
                                    {
                                        disabled:
                                            this.myDSdisbleField[prog] == true,
                                        icon: campo.button.icon,
                                        name: campo.button.name,
                                        onClick: ($event) => {
                                            this.IconTextClick(
                                                $event,
                                                campo.button.name,
                                                campo
                                            );
                                        },
                                    } /*,{
                  disabled: campo.button.disabled,
                  icon: 'clear',
                  name: campo.button.name+'2',
                  onClick: ($event) => {
                    this.IconTextClick($event, campo.button.name);
                  }
                }*/,
                                ];
                                if (campo.showClearButton) {
                                    this.dxitemOptions[prog].push({
                                        disabled:
                                            this.myDSdisbleField[prog] == true,
                                        icon: "clear",
                                        name: campo.button.name + "_clear",
                                        onClick: ($event) => {
                                            this.IconTextClick(
                                                $event,
                                                campo.button.name + "_clear",
                                                campo
                                            );
                                        },
                                    });
                                }
                            }
                            if (campo["dxdropdownbox"]) {
                                ////console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
                                campo["dxdropdownbox"]["index"] = prog;
                                if (!campo.dxdropdownbox.filter) {
                                    campo.dxdropdownbox.filter = "";
                                }
                                let myApiLook =
                                    environment.BASE_API_URL_APIREST +
                                    campo.dxdropdownbox.dataSource;
                                if (this.wingap)
                                    myApiLook =
                                        environment.BASE_API_URL +
                                        campo.dxdropdownbox.dataSource;
                                this.dsLookups[prog] = new CustomStore({
                                    loadMode: "raw",
                                    key: campo.dxdropdownbox.valueExpr,
                                    load: (loadOptions: any) => {
                                        //************************************************************************ */
                                        let params: HttpParams =
                                            new HttpParams();
                                        [
                                            "skip",
                                            "take",
                                            "requireTotalCount",
                                            "requireGroupCount",
                                            "sort",
                                            "filter",
                                            "totalSummary",
                                            "group",
                                            "groupSummary",
                                            "TipoOperazione",
                                        ].forEach((i) => {
                                            if (
                                                i in loadOptions &&
                                                this.isNotEmpty(loadOptions[i])
                                            ) {
                                                let cVal = JSON.stringify(
                                                    loadOptions[i]
                                                );
                                                cVal = cVal.replace(/"/g, "");
                                                params = params.set(i, cVal);
                                            }
                                        });
                                        return this.http
                                            .get(
                                                myApiLook +
                                                campo.dxdropdownbox.filter,
                                                { params }
                                            )
                                            .toPromise()
                                            .then((res) => {
                                                if (res["items"]) {
                                                    res = res["items"];
                                                } else if (res["data"]) {
                                                    res = res["data"];
                                                } else {
                                                    res = res;
                                                }
                                                return res;
                                            });
                                    },
                                });
                            }

                            if (campo["lookup"]) {
                                campo["lookup"]["index"] = prog;
                                if (!campo.lookup.filter) {
                                    campo.lookup.filter = "";
                                }
                                if (campo.lookup.static == true) {
                                    this.dsLookups[prog] = this.dati.getDati(
                                        campo.lookup.dataSource
                                    );
                                } else {
                                    //if(campo.dataField=='idImballo'){
                                    ////console.log("Sono Passato da qua 1",campo);
                                    if (campo.lookup.colonne) {
                                        let optionalColonne =
                                            campo.lookup.colonne;
                                        optionalColonne.forEach((element) => {
                                            if (element.lookup) {
                                                this.optionalDsLookup.push(
                                                    this.customSource(element)
                                                );
                                                element.prog =
                                                    this.optionalDsLookup
                                                        .length - 1;
                                            }
                                        });
                                    }
                                    //}
                                    let myApiLook =
                                        environment.BASE_API_URL_APIREST +
                                        campo.lookup.dataSource;
                                    //if (this.wingap==true) myApiLook = environment.BASE_API_URL + campo.lookup.dataSource;
                                    if (campo.lookup.wingap == true)
                                        myApiLook =
                                            environment.BASE_API_URL +
                                            campo.lookup.dataSource;
                                    myApiLook += campo.lookup.filter;
                                    //alert(myApiLook,"DSLOOKUP")

                                    this.dsLookups[prog] = new CustomStore({
                                        loadMode: "raw",
                                        key: campo.lookup.valueExpr,
                                        onUpdating: function (key, values) {
                                            let Idx = campo["lookup"]["index"];
                                            values["versione"] =
                                                masterThis2.versionValues[Idx][
                                                "versione"
                                                ];
                                            values["nomeTabella"] =
                                                masterThis2.versionValues[Idx][
                                                "nomeTabella"
                                                ];
                                        },
                                        load: (loadOptions: any) => {
                                            let params: HttpParams =
                                                new HttpParams();
                                            [
                                                "skip",
                                                "take",
                                                "requireTotalCount",
                                                "requireGroupCount",
                                                "sort",
                                                "filter",
                                                "totalSummary",
                                                "group",
                                                "groupSummary",
                                                "TipoOperazione",
                                            ].forEach((i) => {
                                                if (
                                                    i in loadOptions &&
                                                    this.isNotEmpty(
                                                        loadOptions[i]
                                                    )
                                                ) {
                                                    let cVal = JSON.stringify(
                                                        loadOptions[i]
                                                    );
                                                    cVal = cVal.replace(
                                                        /"/g,
                                                        ""
                                                    );
                                                    params = params.set(
                                                        i,
                                                        cVal
                                                    );
                                                }
                                            });

                                            //return this.http.get<any>( myApi+this.filter, { params }).toPromise()
                                            return this.http
                                                .get(myApiLook, { params })
                                                .toPromise()
                                                .then((res) => {
                                                    //alert("AVREI LETTO","AVREI LETTO")
                                                    //console.log("avrei lettoooo ",myApiLook);

                                                    if (res["items"]) {
                                                        res = res["items"];
                                                    } else if (res["data"]) {
                                                        res = res["data"];
                                                    } else {
                                                        res = res;
                                                    }
                                                    return res;
                                                });
                                        } /*   
              load: (loadOptions) => this.http.get( myApiLook+ campo.lookup.filter ).toPromise().then(res => {
                 if(loadOptions) alert(""+loadOptions,"eeee")
                 //console.log("loadOptions",loadOptions);
                if(res['items']){
                  res=res['items']
                }else{
                  res=res
                }
                  return res
                }
              ),*/,
                                        insert: (values) => {
                                            if (campo.costantValue) {
                                                campo.costantValue.forEach(
                                                    (element) => {
                                                        values[element["key"]] =
                                                            element["value"];
                                                    }
                                                );
                                            }
                                            return this.http
                                                .post(myApiLook, values)
                                                .toPromise()
                                                .then((res) => {
                                                    //this.dsLookups[campo['lookup']['index']]._loadFunc();//reload();
                                                });
                                        },
                                        //Zorro
                                        update: (key, values) => {
                                            if (campo.costantValue) {
                                                campo.costantValue.forEach(
                                                    (element) => {
                                                        values[element["key"]] =
                                                            element["value"];
                                                    }
                                                );
                                            }
                                            //values['versione']=this.versionValues[prog]['versione']
                                            return this.http
                                                .put(
                                                    myApiLook +
                                                    "/" +
                                                    encodeURIComponent(key),
                                                    values
                                                )
                                                .toPromise()
                                                .then((res) => {
                                                    //this.dsLookups[campo['lookup']['index']]._loadFunc();//reload();
                                                });
                                        },
                                        remove: (key) => {
                                            return this.http
                                                .delete(
                                                    myApiLook +
                                                    "/" +
                                                    encodeURIComponent(key)
                                                )
                                                .toPromise()
                                                .then();
                                        },
                                    });
                                }
                            }
                            if (campo.type == "radioButton") {
                                // Valori Statici

                                console.log(
                                    "ecccccco  ds ",
                                    campo.radioGroup.dataSource
                                );
                                this.dsLookups[prog] = this.dati.getDati(
                                    campo.radioGroup.dataSource
                                );
                                console.log(
                                    "ecccccco  ds ",
                                    this.dsLookups[prog]
                                );
                            }

                            if (campo["static-lista"]) {
                                // json statico

                                this.dsLookups[prog] = this.dati.getDati(
                                    campo.lista.dataSource
                                );
                            }
                            if (campo["dynamic"]) {
                                this.dataDynamic[prog] = campo;
                            }
                            if (campo["lista"]) {
                                if (campo.lista.static == true) {
                                    campo["lista"]["index"] = prog;
                                    if (campo["lista"].Async == true) {
                                        //---------------------------------------------------------------
                                        this.dsLookups[prog] = {
                                            store: new CustomStore({
                                                loadMode: "raw",
                                                key: campo.lista.valueExpr,
                                                load: () =>
                                                    this.dati
                                                        .getDatiAsync(
                                                            campo.lista
                                                                .dataSource,
                                                            ""
                                                        )
                                                        .then((res) => {
                                                            //console.log("Caricati Registr ", res);
                                                            return res;
                                                            let rispo: Object;
                                                            if (res["items"])
                                                                rispo =
                                                                    res[
                                                                    "items"
                                                                    ];
                                                            else rispo = res;
                                                            return rispo;
                                                        }),
                                            }),
                                        };
                                        //----------------------------------------------------------------
                                        /*this.dati.getDatiAsync(campo.lista.dataSource).then(xxx=>{
                        //console.log("Letto i registri ",xxx);
                        this.dsLookups[prog]=xxx
                    })*/
                                    } else
                                        this.dsLookups[prog] = campo.lista.items
                                            ? campo.lista.items
                                            : this.dati.getDati(
                                                campo.lista.dataSource
                                            );
                                } else {
                                    let queryString = "";
                                    if (campo["lista"].queryString) {
                                        //console.log(campo.lista.queryString)
                                        this.activatedroute.queryParams.subscribe(
                                            (params) => {
                                                if (params.filter) {
                                                    //console.log('nicaAnagrafica', params.data)
                                                    let data = JSON.parse(
                                                        params.filter
                                                    );

                                                    if (
                                                        campo.lista.queryString.includes(
                                                            "$"
                                                        )
                                                    ) {
                                                        let arrQuerySTemp =
                                                            campo.lista.queryString.split(
                                                                "$"
                                                            );

                                                        let query =
                                                            arrQuerySTemp[0];

                                                        let filter =
                                                            data[
                                                            arrQuerySTemp[1]
                                                            ];
                                                        if (
                                                            typeof filter !=
                                                            "undefined"
                                                        ) {
                                                            queryString =
                                                                query + filter;
                                                        } else {
                                                            if (
                                                                this
                                                                    .costantValues
                                                            )
                                                                this.costantValues.forEach(
                                                                    (
                                                                        element,
                                                                        key
                                                                    ) => {
                                                                        if (
                                                                            arrQuerySTemp[1] ==
                                                                            element[
                                                                            "key"
                                                                            ]
                                                                        ) {
                                                                            queryString +=
                                                                                query +
                                                                                element[
                                                                                "value"
                                                                                ];
                                                                        }
                                                                    }
                                                                );
                                                        }
                                                    } else
                                                        queryString =
                                                            campo.lista
                                                                .queryString;
                                                } else {
                                                    if (
                                                        campo["lista"]
                                                            .costantValues
                                                    ) {
                                                        campo[
                                                            "lista"
                                                        ].costantValues.forEach(
                                                            (element, key) => {
                                                                let startString;
                                                                if (key == 0) {
                                                                    startString =
                                                                        "?";
                                                                } else {
                                                                    startString =
                                                                        "&";
                                                                }
                                                                queryString +=
                                                                    startString +
                                                                    element[
                                                                    "key"
                                                                    ] +
                                                                    "=" +
                                                                    element[
                                                                    "value"
                                                                    ];
                                                            }
                                                        );
                                                    } else if (
                                                        this.costantValues
                                                    ) {
                                                        this.costantValues.forEach(
                                                            (element, key) => {
                                                                let startString;
                                                                if (key == 0) {
                                                                    startString =
                                                                        "?";
                                                                } else {
                                                                    startString =
                                                                        "&";
                                                                }
                                                                queryString +=
                                                                    startString +
                                                                    element[
                                                                    "key"
                                                                    ] +
                                                                    "=" +
                                                                    element[
                                                                    "value"
                                                                    ];
                                                            }
                                                        );
                                                    } else {
                                                        queryString = "";
                                                    }
                                                }
                                            }
                                        );
                                    } else {
                                        if (campo["lista"].costantValues) {
                                            queryString = "";
                                        } else {
                                            if (this.costantValues) {
                                                this.costantValues.forEach(
                                                    (element, key) => {
                                                        queryString +=
                                                            "?" +
                                                            element["key"] +
                                                            "=" +
                                                            element["value"];
                                                    }
                                                );

                                                //console.log(queryString)
                                            } else {
                                                queryString = "";
                                            }
                                        }
                                    }

                                    // if(!campo.lista.filter) campo.lista.filter=''
                                    campo["lista"]["index"] = prog;

                                    let myApiLook =
                                        environment.BASE_API_URL_APIREST +
                                        campo.lista.dataSource;
                                    let wingAp: boolean =
                                        campo.lista.wingap != undefined
                                            ? campo.lista.wingap
                                            : this.wingap;
                                    if (wingAp)
                                        myApiLook =
                                            environment.BASE_API_URL +
                                            campo.lista.dataSource;
                                    this.dsLookups[prog] = {
                                        store: new CustomStore({
                                            byKey: async (key) => {
                                                const response = await fetch(
                                                    myApiLook + "/" + key
                                                );
                                                const data =
                                                    await response.json();
                                                if (data.data[0])
                                                    return data.data[0];
                                                else return data.data;
                                                /*return (this.http
                                                     .get(myApiLook+"/"+key)
                                                     .toPromise()
                                                     .then((res) => {
                                                            let rispo: Object;
                                                            if (res['items']) rispo = res['items'];
                                                            else if(res['data']) rispo = res['data'];
                                                            else  return rispo;
                                                     }))*/
                                            },
                                            // loadMode: !wingAp
                                            //     ? "processed"
                                            //     : "raw",
                                            loadMode: "raw",
                                            key: campo.lista.valueExpr,

                                            load: (loadOptions) =>

                                                this.http
                                                    .get(
                                                        myApiLook + queryString
                                                    )
                                                    .toPromise()
                                                    .then((res) => {
                                                        let rispo: Object;
                                                        if (res["items"])
                                                            rispo =
                                                                res["items"];
                                                        else rispo = res;
                                                        return rispo;
                                                    }),

                                            insert: (values) => {
                                                if (campo.costantValue) {
                                                    campo.costantValue.forEach(
                                                        (element) => {
                                                            values[
                                                                element["key"]
                                                            ] =
                                                                element[
                                                                "value"
                                                                ];
                                                        }
                                                    );
                                                }
                                                return this.http
                                                    .post(myApiLook, values)
                                                    .toPromise()
                                                    .then((res) => {
                                                        // this.dsLookups[campo['lookup']['index']]._loadFunc();//reload();
                                                    });
                                            },
                                        }),
                                        paginate: true,
                                        pageSize: 100
                                    };
                                }
                                // this.dsLookups[i+j]=this.dati.getDati(campo.lista.dataSource);
                            }
                        });
            });
            console.log("datiGriglia", this.datiGriglia);
            ////////console.log(this.editorTabDisabled)
            //////console.log("ecco le colonne prima di order ",this.colonneGriglia)
            ////console.log("Ecco this.colonneGriglia ",this.colonneGriglia)

            //settaTemplate
            eval("settaTemplate(this.colonneGriglia);");
            this.colonneGriglia.forEach((element, i) => {
                if (!element.orderGriglia) element["orderGriglia"] = 99999999;
                this.colonneGrigliaTabella.push(element);
                if (element.dataField > "")
                    this.colonnePerField[element.dataField] = element;
            });

            this.colonneGrigliaTabella.sort(function (a, b) {
                return a.orderGriglia - b.orderGriglia;
            });

            //this.colonneGrigliaTabella=this.colonneGriglia
            console.log(
                "ecco le colonne dopo di order ",
                this.colonneGrigliaTabella
            );
        }

        // this.appService.GetProvincie()
        //  .then(response=>{
        // this.dsLookups[4]=response;

        //  });

        //this.dati.getDati('provincie').then(response=>{
        // this.dsLookups[4]=response;
        // //////console.log("pppppppppppppppppp ",response);
        //})

        //'https://www.webrifiuti.it/api/index.php?azione=ReadTabella&table=login' 'https://www.webrifiuti.it/api/index.php'
        let myApi = environment.BASE_API_URL_APIREST + this.api;
        //console.log('myApi',myApi)
        if (this.wingap) myApi = environment.BASE_API_URL + this.api;
        let no = 1;
        if (this.asDetail && no == 0) {
            console.log(
                "DETTAGLIOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO "
            );
            this.myDs = new CustomStore({
                key: "id",

                load: (loadOptions: any) =>
                    //this.http.get(myApi + '/' + this.asDetail.chiave + '=' + this.detailValue
                    this.http.get(myApi + "" + this.detailValue).toPromise(),
                insert: (values) => {
                    values[this.asDetail.chiave] = this.detailValue;
                    //////console.log(values)
                    return this.http
                        .post(myApi, values)
                        .toPromise()
                        .then((res) => {
                            //////console.log(res), //////console.log(values)
                        })
                        .catch();
                },
                update: (key, values) => {
                    return this.http
                        .put(myApi + "/" + encodeURIComponent(key), values)
                        .toPromise()
                        .then((res) => {
                            ////console.log("Ritorno da Update ",res);
                            ////console.log("Ritorno da Update ",values)
                            //////console.log(values)
                        });
                },
                remove: (key) => {
                    return this.http
                        .delete(myApi + "/" + encodeURIComponent(key))
                        .toPromise()
                        .then();
                },
            });
        } else {
            if (!this.wingap) {
                this.myload = "processed";
            } else {
                this.myload = "raw";
            }
            //////console.log('wingap var:',this.wingap);
            //////console.log('myload var:',this.myload);
            //alert(myApi+this.filter);
            let tt = this;

            this.myOdata = {
                store: {
                    type: "odata",
                    url: myApi + this.filter,
                    key: this.masterKey,
                },
            };
            if (!this.isDataStatic) this.myDsStatic = [];
            this.myDs.this = this;
            this.myDs.store = new CustomStore({
                errorHandler: function (error) {
                    //this.appService.parseHttpErrorResponse(error);
                    //////console.log("In Error Handle Griglia ",error);
                    //alert("error",error);
                    //alert(error.message,"error Handle in errore handle");
                    //this.myDs.formEdit;
                },
                key: this.masterKey,

                // loadMode:this.myload,

                onLoading: function (values) {
                    // alert("in onLoading","onLoading");
                    //console.log(" In Loadingggggggggg ",values);
                    //let event={name:'',values:null};
                    //event.name="onLoading";
                    //let masterThis = eval("findmasterThis();")
                    //event.values=values;
                    //masterThis.onAllEvent.emit(event);
                    //values=event.values
                    //this.load(values);
                    //values=event.values
                },

                onInserted: function (values, key) {
                    // alert("in inserted","in inserted");
                },

                //ZORRO
                load: (loadOptions: any) => {
                    //************************************************************************ */
                    if (loadOptions.take)
                        loadOptions.take = parseInt(loadOptions.take as any);
                    let params: HttpParams = new HttpParams();

                    [
                        "skip",
                        "take",
                        "requireTotalCount",
                        "requireGroupCount",
                        "sort",
                        "filter",
                        "orderby",
                        "totalSummary",
                        "group",
                        "groupSummary",
                        "filterCustom",
                    ].forEach((i) => {
                        //            //console.log("Ecco prima params key=",i)
                        //          //console.log("Ecco prima params value=",loadOptions[i])
                        if (
                            i in loadOptions &&
                            this.isNotEmpty(loadOptions[i])
                        ) {
                            params = params.set(
                                i,
                                JSON.stringify(loadOptions[i])
                            );
                        }
                    });

                    //************************************************************************ */

                    /*
         const filterBackup = JSON.parse(JSON.stringify(this.filter));

         this.activatedroute.queryParams.subscribe(
             (paramsAttivi)=>{
                 if(paramsAttivi.service)
                 if(!paramsAttivi.service)
                 return;

                 this.filterTemplateName = paramsAttivi.service.concat('Filtri');
                 
                 if(localStorage.getItem(this.filterTemplateName) && this.filter.length>0 && this.griglia.instance.getCombinedFilter()){
                     //this.filter = "";
                     //console.warn();
                     

                     


                     localStorage.removeItem(this.filterTemplateName);

                     for (let i = 0; i < document.getElementsByClassName('dx-icon glyphicon mdi mdi-filter-outline').length; i++) {

                         if ((document.getElementsByClassName('dx-icon glyphicon mdi mdi-filter-outline').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {
 
 
                             (document.getElementsByClassName('dx-icon glyphicon mdi mdi-filter-outline').item(i) as HTMLElement).style.color = '#023957';
 
                             break;
                         }
 
                     }

                 }
                 
             }
         )*/

                    //values=event.values
                    //this.load(values);
                    //values=event.values

                    //console.log('NicaNagrafica', params)
                    //params.set('filterCustom','{ciccio:pappa}')
                    //console.log('NicaNagrafica s--------------', params)

                    if (myApi.includes("?") && typeof this.filter == "string") {
                        this.filter =
                            "&" + this.filter.substring(1, this.filter.length);
                    }

                    return (
                        this.http
                            .get<any>(myApi + this.filter, { params })
                            .toPromise()
                            //return this.http.get<any>( myApi+this.filter).toPromise()
                            .then((res) => {
                                let rispo;
                                /*let rs2={
                    "data": res['items'],
                    "totalCount": res['totalCount'],                       
                }*/

                                //return rs2;
                                ////console.log("Eccooooooooooo i data in ODATA ",res)
                                ////console.log("Eccooooooooooo i data in ODATA ",this.remoteOperations)

                                if (res["items"]) {
                                    rispo = res["items"];
                                } else {
                                    if (res["licenze"]) {
                                        rispo = res["licenze"].filter((x: any) => x.id !== '00000');
                                    } else rispo = res;
                                }

                                let e = {
                                    name: "endLoad",
                                    componentName: this.name,
                                    count: rispo.length,
                                    totalCount: res.totalCount,
                                };
                                if (res.totalCount == 0) delete e.totalCount;
                                this.onAllEvent.emit(e);

                                if (this.wingap == false) {
                                    let r = this.checkLoad(rispo);

                                    //alert(res['data'].length,"e");
                                    //console.warn(this.filter);
                                    if (r["data"]) {
                                        return r["data"];
                                    } else {
                                        return res;
                                    }
                                }

                                this.dataDynamic.forEach((ress) => {
                                    rispo.map((resu, index) => {
                                        if (
                                            typeof resu[ress.dataField] !=
                                            "undefined"
                                        ) {
                                            if (!resu[ress.dataField]) {
                                                return;
                                            }
                                            if (!ress.colVisible) {
                                                return;
                                            }
                                            let dynamicConf = ress["dynamic"];
                                            let querystring = "";
                                            if (
                                                dynamicConf["valueExpr"] != ""
                                            ) {
                                                if (
                                                    Array.isArray(
                                                        resu[ress.dataField]
                                                    )
                                                ) {
                                                    return;
                                                }

                                                if (
                                                    typeof dynamicConf[
                                                    "queryString"
                                                    ] != "undefined"
                                                ) {
                                                    querystring =
                                                        dynamicConf[
                                                        "queryString"
                                                        ];
                                                }
                                                let api = "";
                                                if (
                                                    dynamicConf[
                                                        "dataSource"
                                                    ].includes("/") ||
                                                    dynamicConf[
                                                        "dataSource"
                                                    ].includes("?")
                                                ) {
                                                    api =
                                                        dynamicConf[
                                                        "dataSource"
                                                        ] +
                                                        resu[ress.dataField] +
                                                        querystring;
                                                } else {
                                                    api =
                                                        dynamicConf[
                                                        "dataSource"
                                                        ] +
                                                        "/" +
                                                        resu[ress.dataField] +
                                                        querystring;
                                                }
                                                if (
                                                    typeof resu[
                                                    ress.dataField
                                                    ] == "undefined"
                                                ) {
                                                    return;
                                                }
                                                this.appService
                                                    .GetApi(api)
                                                    .then((resrrr) => {
                                                        //console.log(resrrr['descrizione'])

                                                        if (
                                                            typeof dynamicConf.related !=
                                                            "undefined"
                                                        ) {
                                                            const related =
                                                                dynamicConf.related;

                                                            related.forEach(
                                                                (rel) => {
                                                                    let arrayRelated =
                                                                        rel.split(
                                                                            "|"
                                                                        );
                                                                    if (
                                                                        arrayRelated.length >
                                                                        0
                                                                    ) {
                                                                        resu[
                                                                            arrayRelated[1]
                                                                        ] =
                                                                            resrrr[
                                                                            arrayRelated[0]
                                                                            ];
                                                                    } else {
                                                                        resu[
                                                                            arrayRelated
                                                                        ] =
                                                                            resrrr[
                                                                            arrayRelated
                                                                            ];
                                                                    }
                                                                }
                                                            );
                                                        }
                                                    });
                                            }
                                        }
                                    });
                                });
                                /* return {                
                 "data": res['items'],//res,
                 "totalCount": res['totalCount']
                 
         };*/

                                //dettagliCer

                                let r = this.checkLoad(rispo);

                                return {
                                    data: r, //res,
                                    totalCount: res["totalCount"],
                                };

                                /*//console.log("vvvvvvvvvvvvvvvvvvvvvvvvv ", res);
                this.checkLoad(res).then(result=>{
                //console.log("vvvvvvvvvvvvvvvvvvvvvvvvv ", result);
 
                    return {                
                        data: result,
                        totalCount: res['totalCount']
                      
                };
 
                })*/
                                /*
                                        res.forEach(element => {
                                            this.appService.GetApi('Cer/'+element.cer).then(response=>{
                                                // //console.log(e.rowIndex);                  
                                                element.Descrizione=response['descrizione'];             
                                        })        
          
                                        });
          
                                        return {                
                                            data: res,
                                            totalCount: res['totalCount']
                                          
                                    };
          
                                        return res['items'];
                                    */
                            })
                            .catch((error) => {
                                /* let name 
            name.event.name="ErrorLoader";
            name.event.componentName=this.name;
            this.onAllEvent.emit(name); */

                                //console.warn(this.filter);

                                throw "Data loading error";
                            })
                    );
                },
                insert: (values) => {
                    if (this.costantValues) {
                        this.costantValues.forEach((element) => {
                            values[element["key"]] = element["value"];
                        });

                        //////console.log(values)
                    }
                    return (
                        this.http
                            .post(myApi, values)
                            .toPromise()
                            .then(
                                (res) => {
                                    //alert("ritorno",myApi);
                                    // ////////console.log(values);
                                    if (res["codeMessage"] == -1) {
                                        alert(
                                            res["descrMessage"],
                                            "Errore Inserimento"
                                        );
                                        //this.myDs.formEdit();
                                        //this.myDs.insert(values).then(function() {
                                        // this.dataSource.reload();
                                        this.masterThis.grigliaMaster.formEdit();
                                    }
                                    return false;
                                }
                                //}
                            )
                            //.catch(error =>{alert("ffff","rrrrr")});
                            .catch((error) => {
                                this.masterThis.grigliaMaster.formEdit();
                                alert(error, "Server Error E101");
                                throw "Data loading error";
                            })
                    );
                },
                update: (key, values) => {
                    /*if(this.costantValues){
             this.costantValues.forEach(element => {
                 values[element['key']]=element['value'];                      
             });
 
             //////console.log(values)
         } */
                    //////console.log("UPPPPPPPPPPPPPPPPPPPPPPPPPPDATE ",values);
                    return (
                        this.http
                            .put(myApi + "/" + encodeURIComponent(key), values)
                            //ssssssssssssssssss
                            .toPromise()
                            .then((res) => {
                                ////console.log("Ritorno da Update ",res);
                                ////console.log("Ritorno da Update ",values)
                                if (res["codeMessage"] == -1) {
                                    alert(
                                        res["descrMessage"],
                                        "Errore Inserimento"
                                    );
                                    this.masterThis.grigliaMaster.formEdit();
                                }
                            })
                            .catch((error) => {
                                //alert("Eccomi","eccomi");
                                //alert(error,'Errore 1 in Update');////////console.log("In update",error);
                                //return false;
                                //tt.myDs.formEdit();
                                this.masterThis.grigliaMaster.formEdit();
                            })
                    );
                },
                remove: (key) => {
                    return this.http
                        .delete(myApi + "/" + encodeURIComponent(key))
                        .toPromise()
                        .then((e) => {
                            setTimeout(() => {
                                this.refresh();
                            }, 200);
                        });
                },
            });
        }
    }
    ngOnChanges(change: SimpleChanges) {
        //////console.log("Cambiooooooooooooo",change);
        //////console.log('chiavi dettagli: ',this.detailValue);
    }
    logga(e: any) {
        //////console.log(e);
    }

    onEditorPreparing(e: any) {
        if (this.stopPropagation) return;
        //this.spinner.show();

        ////console.log("xxxxxxxxxxxxxxxxxxxxxxx")
        e.name = "onEditorPreparing";
        e.componentName = this.name;
        this.onAllEvent.emit(e);

        if (e.rowType === "filter") {
            // //console.log("BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB ",e)
            //let commandCell = e.cellElement;
            // e.editorOptions = { placeholder: "" }
            //commandCell.innerHTML = '<span style="font-weight:400" class="headerGrid">'+e.cellElement.innerText; +'</span>';
            //return e.caption;
            //commandCell.classList.add('headerGrid')
        }

        return;
        //this.currentRow = e.data;
        if (e.parentType === "dataRow") {
            //} && e.dataField == 'userName') {
            //alert("wwwww","wwww")
            // //console.log("In NICA ANAGRAFICA onEditorPreparingX ",this.colonneGriglia)
            for (var tt = 0; tt < this.colonneGriglia.length; tt++) {
                ////console.log("Cerca disabilitato ",e.dataField)
                if (this.colonneGriglia[tt].dataField === e.dataField) {
                    ////console.log("In NICA ANAGRAFICA onEditorPreparing ",e.dataField,)
                    e.name = "onEditorPreparing";
                    //console.log("myDisabled ",tt)
                    //console.log("myDisabled ",this.myDSdisbleField[tt])

                    e.disable = this.myDSdisbleField[tt]; // false; OGGI
                    //e.componentName = this.name;
                    //this.onAllEvent.emit(e);
                    if (
                        this.colonneGriglia[tt].disableOnUpdate === true &&
                        this.colonneGriglia[tt].type !== "button"
                    ) {
                        e.editorOptions.disabled = !this.masterThis.isNewRecord; //true
                    } else {
                        e.editorOptions.disabled = e.disable; //this.colonneGriglia[tt].disabledRunTime;
                    }
                    if (this.colonneGriglia[tt].type === "button") {
                        e.visible = false; //true
                    }
                }
            }
            e.name = "onEditorPreparing";
            e.componentName = this.name;
            this.onAllEvent.emit(e);
            //this.selezionaRiga(e.row.data[this.masterKey]);
        }
    }

    onRowDblClick(e: any) {
        //alert("doppio click","doppio");
        if (e) {
            e.name = 'onRowDblClick'
            e.componentName = this.name;
            e.masterComponent = this
        }
        this.onAllEvent.emit(e)
    }

    onCellPreparedLook(e: any) {
        e.name = "onCellPreparedLook";
        e.componentName = this.name;
        e.dataField = e.column.dataField;
        this.onAllEvent.emit(e);

        if (e.rowType === "header") {
            let commandCell = e.cellElement;
            commandCell.innerHTML =
                '<span style="font-weight:400" class="headerGrid">' +
                e.cellElement.innerText;
            +"</span>";
        }
    }

    onCellPrepared(e: any) {
        e.name = "onCellPrepared";
        e.componentName = this.name;
        e.dataField = e.column.dataField;
        this.onAllEvent.emit(e);

        if (e.rowType === "filter" && e.column.dataField == "userName") {
            ////console.log("pppppppppppppppppppppppppppppppp ",e)
            //e.column.editorOptions.inputAttr.placeholder='';
            //let commandCell = e.cellElement;
            //e.cellElement.editorOptions = { placeholder: "" }
            // e.cellElement.innerHTML = '';
            //return e.caption;
            //commandCell.classList.add('headerGrid')
        }
        if (e.rowType === "header") {
            //////console.log("CELLLLPREPRED ",e);
            let commandCell = e.cellElement;
            commandCell.editorOptions = { placeholder: "" };
            //commandCell.innerHTML = '<span style="font-weight:400" class="headerGrid">'+e.cellElement.innerText; +'</span>';
            //return e.caption;
            commandCell.classList.add("headerGrid");
        }

        if (e.rowType == "data") {
            //&& e.column.dataField == "ragioneSociale"
            if (this.colonnePerField[e.dataField] && this.colonnePerField[e.dataField]['clone'] && this.colonnePerField[e.dataField]['clone'] != '') {
                e.cellElement.innerHTML = e.data[this.colonnePerField[e.dataField]['clone']];
                e.data[e.dataField] = e.data[this.colonnePerField[e.dataField]['clone']]
            }
            if (e.key == this.keyEspansa)
                e.cellElement.className += this.classEvidenziaMaster; //" employee";
        }

        /*if(e.rowType === 'data'){
         if(e.column.dataField=="guidAccettazione"){
                e.cellElement.innerHTML="wwww";
    }
}*/
    }
    onContentReady(e: any) {
        /*
    if(e.component.getCombinedFilter()){

        this.griglia.instance.clearFilter();
        this.activatedroute.queryParams.subscribe(
            (params) => {
                          
                this.filterTemplateName = params.service.concat('Filtri');

                localStorage.removeItem(this.filterTemplateName);

                this.filter = '';
        }
    );
    }
    */
        //if(!e.component.hasEditData()) // nothing edited
        //this.isEditing = false; // else this.isEditing = true;
        //////console.log("In On content messo a false");
        e.name = "onContentReady";
        e.componentName = this.name;
        e.masterComponent = this
        this.onAllEvent.emit(e);
    }

    onInitilized(e) {
        e.name = "onInitilized";
        e.componentName = this.name;
        e.contentComponent = this;
        e.masterComponent = this;
        this.onAllEvent.emit(e);
    }

    //A function that is executed before pending row changes are saved.
    onSaving(e: any) {
        console.log(e);
        e.name = "onSaving";
        e.componentName = this.name;
        e.oldData = this.dataRowSelected;
        //console.log("OnSaving in Nica Anagrafica ", e.oldData);
        this.onAllEvent.emit(e);
        if (this.modeEdit === "row") {
            console.log(e);
        }
        //e.cancel=true;
        ////////console.log("OnSaving in Nica Anagrafica ",e);
        //e.changes[0]['data']['idSoggetto']=11111111
    }
    // A function execute after saved
    onSaved(e: any) {
        ////////console.log("OnSaving",e.component.getRowElement());
        e.name = "onSaved";
        e.componentName = this.name;
        this.onAllEvent.emit(e);
        this.isNewRecord = false;
    }
    onRowUpdated(e: any) {
        e.name = "onRowUpdated";
        e.componentName = this.name;
        e.masterThis = this.masterThis;
        this.onAllEvent.emit(e);

        //////console.log("onRowUpdated",e);
    }
    onDataErrorOccurred(event) {
        event.name = "onDataErrorOccurred";
        event.componentName = this.name;
        this.onAllEvent.emit(event);
        //alert("onDataErrorOccurred","Errore");
        //////console.log("onDataErrorOccurred",event);
    }
    onRowValidating(event) {
        event.name = "onRowValidating";
        event.componentName = this.name;
        this.onAllEvent.emit(event);

        if (typeof this.validaDati == "function") {
            event = this.validaDati(event);
            //if(event.errorText) alert(event.errorText,"Registrazione Dati");
        }

        //event.isValid=this.ValidateRow(event);
    }

    onOpenedLook(event, element, model) {
        console.log("On Opened event", event);
        console.log("On Opened element", element);
        console.log("On Opened model", model);
        setTimeout(() => {
            // this.name_lookup_pippo.instance.close();
            //event.instance.close();
        }, 1000);

        return;
        //console.log("On Opened ", $event)
        //console.log("On Opened element", element)
        //console.log("On Opened model", model)
        let dataGrid = model.griglia.instance;
        let iDX: any;
        iDX = { field: "", flag: false };
        //if(element.lookup && element.lookup.related && element.lookup.related[0].static==true) return;

        let myComponent = null;
        //let GridComponent = this.name_lookup.toArray(); //griglia
        //GridComponent.forEach(elemento => {
        //if (elemento.element.nativeElement.id == 'lookup' + element.prog) myComponent = elemento;
        //if (elemento.element.nativeElement.id == 'lookup' + element.prog) myComponent = elemento;
        //});
        if (myComponent) myComponent.instance.refresh();

        if (element.lookup && element.lookup.related) {
            iDX = {
                field: element.lookup.related[0].dataField,
                api: element.lookup.related[0].api,
                displayExpr: element.lookup.related[0].displayExpr,
                valueExpr: "",
                flag: true,
            };
            eval("settaRelation(iDX)");
        }

        if (element.prog == this.relationRecord.related_prog) {
            iDX = {
                field: "",
                flag: false,
                api: "",
                displayExpr: "",
                valueExpr: "",
            };
            eval("settaRelation(iDX)");
            let myComponent = null;
            //let GridComponent = this.name_lookup.toArray(); //griglia
            //GridComponent.forEach(elemento => {
            //if (elemento.element.nativeElement.id == 'lookup' + element.prog) myComponent = elemento;
            //if (elemento.element.nativeElement.id == 'lookup' + element.prog) myComponent = elemento;
            //});
            if (myComponent) myComponent.instance.refresh();
            this.dsLookups[element.prog].__rawData =
                this.relationRecord.records;
        }
    }
    valueChanged($event) {
        //console.log("ho cambiato ", $event)
    }

    onInitializedLookUp(element, instance) {
        console.log("Ecco il record selezionato ", instance); //.instance.getSelectedRowsData()[0]);
    }

    onSelectionChangedLook(
        selectedRowKeys,
        cellInfo,
        dropDownBoxComponent,
        colonna,
        gr
    ) {
        console.log("Ecco il record del dblookup ", gr); //.instance.getSelectedRowsData()[0]);

        console.log("wwwwwwwwwwwwwwww selectedRowKeys", selectedRowKeys);
        console.log("wwwwwwwwwwwwwwww cellInfo", cellInfo);

        if (cellInfo.data[cellInfo.item.dataField] === cellInfo.value[0])
            return;
        //cellInfo.item.dataField
        // cellInfo.data
        // value:value array

        //var objActual = this.mythis.griglia.instance.getController("editing");
        //var actualData = objActual._dataController._items[0]['data'];
        ////console.log("Ecco i dati della griglia objActual", objActual);
        ////console.log("Ecco i dati della griglia actualData", actualData);
        ////console.log("Ecco i dati della griglia cellInfo", cellInfo);

        //objActual._dataController._items[0]['data']['descrizione']='pippo' //OK
        if (colonna.related && colonna.related[0].api) {
            this.appService
                .GetApi(colonna.related[0].api + cellInfo.value)
                .then((response) => {
                    cellInfo.component.cellValue(
                        0,
                        colonna.related[0].dataField,
                        response[colonna.related[0].displayExpr]
                    );
                    // cellInfo.data[colonna.related[0].dataField]=response[colonna.related[0].displayExpr] // ok
                });
        }

        cellInfo.setValue(selectedRowKeys[0]);
        dropDownBoxComponent.close();
        return; // da eliminare
        if (selectedRowKeys.length > 0) {
            let iDX: any;
            iDX = { field: "", flag: false };
            //...........................................
            if (colonna.related) {
                let iDX = {
                    api: colonna.related[0].api,
                    displayExpr: colonna.related[0].displayExpr,
                    field: colonna.related[0].dataField,
                    flag: true,
                };
                //eval("settaRelation(iDX)");
                let cRelat = null;
                colonna.related.forEach((element) => {
                    cRelat = this.colonneGrigliaTabella.find(
                        (t) => t.dataField === element.dataField
                    );
                });
                if (cRelat) {
                    let myFilter: Array<any> = [];
                    let xx;
                    let gg = colonna.related[0].filter_relation;
                    xx = { [gg]: cellInfo.value };
                    let prg = cRelat.prog;
                    if (this.colonneGrigliaTabella[prg].lista) {
                        if (
                            this.colonneGrigliaTabella[prg].lista.static ==
                            true &&
                            this.colonneGrigliaTabella[prg].lista.Async == false
                        ) {
                            let ds =
                                this.colonneGrigliaTabella[prg].lista
                                    .dataSource; //TipoTrasporto
                            this.dsLookups[prg] = this.dati.getDati(
                                ds,
                                cellInfo.value
                            );
                        } else {
                            this.relationRecord = {
                                masterValue: cellInfo.value,
                                master_prog: colonna.index,
                                related_prog: prg,
                                related: gg,
                            };
                            let ds =
                                this.colonneGrigliaTabella[prg].lista
                                    .dataSource;
                            //-------------------------------------------------
                            this.dsLookups[prg] = {
                                store: new CustomStore({
                                    loadMode: "raw",
                                    load: () =>
                                        this.dati
                                            .getDatiAsync(ds, cellInfo.value)
                                            .then((res) => {
                                                return res;
                                            }),
                                }),
                            };
                            //-------------------------------------------
                        }
                    } // END campo lista
                    /*
         if(colonna.related && colonna.related[0].api){
            this.appService.GetApi(colonna.related[0].api+cellInfo.value).then(response=>{
             let iDX={field:colonna.related[0].dataField,
                 api:colonna.related[0].api,
                 displayExpr:colonna.related[0].displayExpr,
                 valueExpr:response[colonna.related[0].displayExpr],
                 flag:true};
                 eval("settaRelation(iDX)"); 
                 
                 this.relationRecord={ 
                     'records':response,               
                     'valueExpr':response[colonna.related[0].displayExpr],
                     'displayExpr':colonna.related[0].displayExpr,
                     'masterValue':cellInfo.value,
                     'master_prog':colonna.index,
                     'related_prog':prg,                
                     };                 
             })
         }
         */
                    if (
                        colonna.related &&
                        !colonna.related[0].api &&
                        !colonna.related[0].static
                    ) {
                        this.dsLookups[prg]._loadFunc(xx).then((pp) => {
                            this.relationRecord = {
                                records: pp,
                                masterValue: cellInfo.value,
                                master_prog: colonna.index,
                                related_prog: prg,
                                related: gg,
                            };
                            cellInfo.component.cellValue(
                                0,
                                colonna.related[0].dataField,
                                ""
                            );
                            cellInfo.component.refresh();
                            this.griglia.instance.refresh();
                        });
                    }
                    //-----------------
                    if (
                        colonna.related &&
                        !colonna.related[0].api &&
                        colonna.related[0].static
                    ) {
                        // let ds=this.colonneGrigliaTabella[prg].lista.dataSource;//TipoTrasporto
                        //this.dsLookups[prg]=this.dati.getDati(ds,cellInfo.value);
                    }

                    // //console.log("VIEW CHILD name_lookup ",this.name_lookup.toArray()[0]);
                    ////console.log("VIEW CHILD name_items",this.name_items.toArray());
                }
            }
        }
        //dropDownBoxComponent.close();

        return;
        ////////console.log(cellInfo)
    }

    syncTreeViewSelection(e: any, setValueMethod: any) {
        //    e.cellInfo.setValue('')
        if (e.value == null) setValueMethod(e.value);

        console.log("syncTreeViewSelection", e);
        //alert("www","www")
        /*previousValue value*/
        /*e.name = "syncTreeViewSelection";
    e.componentName = this.name;
    let cc=this.onAllEvent.emit(e);
    setValueMethod(cc);  
    this.cdr.detectChanges();
    */
    }

    cellTemplatedxdropdownbox(container, options) {
        //console.log("container ", container)
        //console.log("options ", options)
        const noBreakSpace = "\u00A0";
        const text = (options.value || [])
            .map((element) => options.column.lookup.calculateCellValue(element))
            .join(", ");
        container.textContent = text || noBreakSpace;
        container.title = text;
    }

    setCellValuePers($event) {
        //console.log("$setCellValuePers ", $event)
    }
    GenerateEditorRadio(colonna) {
        console.log("qwqwqwqwqwqwqwqwqwqwq ", this.dsLookups[colonna.prog]);
        return {
            dataSource: this.dsLookups[colonna.prog],
            displayExpr: colonna.radioGroup.displayExpr,
            valueExpr: colonna.radioGroup.valueExpr,
            onValueChanged: ($event) => {
                console.log("CAMBIATOOOOOOOOOOOOOOOOOOOOOOOOOOOO");
            },
        };
    }
    onValueChangedRadioGroup(e, datafield) {
        //console.log("eeeeeeeeeeeeeeeeeeeeee ",e)
        //console.log("eeeeeeeeeeeeeeeeeeeeee ",datafield)
        this.settaField(datafield, e.value);
    }

    setCellValue(rowData: any, value: any, currentRowData: any): void {
        console.log("SETTOOOOOOOOOOOOOOOO setCellValue ", rowData, value);
        (<any>this).defaultSetCellValue(rowData, value);
        return;
        //console.log("SETTOOOOOOOOOOOOOOOO setCellValue ", rowData, value);

        //console.log(this.dataField);
        let LeColonne = eval("findTemplate();");
        let e: any = {};
        let masterThis = eval("findmasterThis();");
        LeColonne.forEach((element) => {
            if (element.dataField == this.dataField) {
                //console.log("Trovato ", element);
                e.name = "setCellValue";
                e.dataField = this.dataField;
                e.rowData = rowData;
                e.value = value;
                e.currentRowData = currentRowData;
                e.masterThis = masterThis;
                let rr = this.dataField;
                if (value !== currentRowData[this.dataField]) {
                    masterThis.onAllEvent.emit(e);
                    //alert(e.value,"dopo modifica");
                    currentRowData = e.currentRowData;
                    //console.log("pippo ", this);
                    value = e.value;
                    (<any>this).defaultSetCellValue(rowData, value);
                } else (<any>this).defaultSetCellValue(rowData, value);
            }
        });
        //(<any> this).defaultSetCellValue(rowData, value);
    }

    /*onValueChangedCell(e:any){
     //console.log("MODIFICAAAAAAAAAAAAAA value changed ",e);
 }*/
    UpdateDSInitizialed(colonna, relatedColumn, value, rowData) {
        if (colonna.lookup.related[0].api) return;

        let xx;
        let gg = colonna.lookup.related[0].filter_relation;
        xx = { [gg]: value };
        if (relatedColumn.lista) {
            this.dsLookups[relatedColumn.prog] = {
                store: new CustomStore({
                    loadMode: "raw",
                    load: () =>
                        this.dati.getDati(
                            relatedColumn.lista.dataSource,
                            value
                        ),
                }),
            };
        }
        if (relatedColumn.lookup) {
            if (relatedColumn.lookup.static) {
                //console.log(relatedColumn)
                this.dsLookups[relatedColumn.prog] = {
                    store: new CustomStore({
                        loadMode: "raw",
                        load: () =>
                            this.dati.getDati(
                                relatedColumn.lookup.dataSource,
                                value
                            ),
                    }),
                };
            } else {
                // xx= xx.replace(/"/g,"");
                this.dsLookups[relatedColumn.prog]._loadFunc(xx).then((pp) => {
                    this.dsLookups[relatedColumn.prog].__rawData = pp;
                    //console.log("IN REFRSH ", pp, xx)
                    //rowData[colonna.lookup.related[0].dataField] = null
                });
            }
        }
    }

    CaricaDS(colonna, relatedColumn, value, rowData) {
        if (colonna.lookup.related[0].api) return;

        let xx;
        let gg = colonna.lookup.related[0].filter_relation;
        xx = { [gg]: value };

        if (relatedColumn.lista) {
            this.dsLookups[relatedColumn.prog] = {
                store: new CustomStore({
                    loadMode: "raw",
                    load: () =>
                        this.dati.getDati(
                            relatedColumn.lista.dataSource,
                            value
                        ),
                }),
            };
        }
        if (relatedColumn.lookup) {
            if (relatedColumn.lookup.static) {
                //console.log(relatedColumn)
                this.dsLookups[relatedColumn.prog] = {
                    store: new CustomStore({
                        loadMode: "raw",
                        load: () =>
                            this.dati.getDati(
                                relatedColumn.lookup.dataSource,
                                value
                            ),
                    }),
                };
            } else {
                // xx= xx.replace(/"/g,"");
                //['eer', 'endswith', 'me', columnIndex: 3, filterValue: 'me']
                //[ "eer", "=", 3 ]
                this.colonneGrigliaTabella[relatedColumn.prog].lookup.filter =
                    "?$filter=" + gg + " eq '" + value + "'"; //  dsLookups[relatedColumn.prog].
                this.dsLookups[relatedColumn.prog]._loadFunc(xx).then((pp) => {
                    this.dsLookups[relatedColumn.prog].__rawData = pp;
                    if (
                        this.colonneGrigliaTabella[relatedColumn.prog].lookup
                            .instanceGrid
                    )
                        this.colonneGrigliaTabella[
                            relatedColumn.prog
                        ].lookup.instanceGrid.refresh();
                    console.log(
                        "IN REFRSH ",
                        colonna.lookup.related[0].dataField
                    );
                    // this.settaField(colonna.lookup.related[0].dataField,null)
                    rowData[colonna.lookup.related[0].dataField] = null;
                });
            }
        }
    }

    setStateValueLook2(e, e1, e2, e3, e4) {
        alert("wwwwwwwwwwwwwwww", "wwwwwwwwwwwwwwwwwww");
        console.log(this);
    }
    setStateValueLook(rowData: any, value: any, extra: any, extra2: any): void {
        if (!value) return;

        console.log("------------------xxxx----------------------------", this);
        let myThis = eval("findmasterThis()");
        console.log("setStateValueLook rowData", rowData);
        //console.log("setStateValueLook this", this);
        //console.log("setStateValueLook field", this.dataField);
        // //console.log("Ecco colonna ", myThis.returnElementsInGriglia([this.dataField]));
        console.log("Ecco il valore ", value);
        console.log("Ecco extra ", extra);
        //colonna.lookup.related[0]
        let colonnax = myThis.returnElementsInGriglia([this.dataField]);
        let colonna = colonnax[0];

        let relatedColumn = null;
        let cValue = value;
        while (colonna) {
            relatedColumn = null;
            if (colonna.lookup && colonna.lookup.related) {
                relatedColumn = myThis.returnElementsInGriglia([
                    colonna.lookup.related[0].dataField,
                ])[0];
            }
            if (relatedColumn) {
                myThis.CaricaDS(colonna, relatedColumn, cValue, rowData);
                var objActual =
                    myThis.mythis.griglia.instance.getController("editing");
                var actualData = objActual._dataController._items[0]["data"];
                objActual._dataController._items[0]["data"][
                    colonna.lookup.related[0].dataField
                ] = null; //OK
                //rowData['descrizione'] = 'pippo'
                cValue = "";
            }
            colonna = relatedColumn;
        }
        /*
        while (colonna) {   
                if(colonna.lookup && colonna.lookup.related){
                    let relatedColumn=myThis.returnElementsInGriglia([colonna.lookup.related[0].dataField])[0];
                    if(!colonna.lookup.api && !colonna.lookup.static) {
                        if(relatedColumn.lista && relatedColumn.lista.static){
                            //rowData[colonna.lookup.related[0].dataField] = ''
                            let ds=relatedColumn.lista.dataSource;
                            //console.log("ds=",ds);
                            //console.log("prog=",relatedColumn.prog);
                            //console.log("value=",colonna.lookup.related[0].dataField);
                            myThis.refreshDs(relatedColumn.prog,value)
                        }
                        else{
                                myThis.CaricaDS(colonna,relatedColumn,value,rowData);
                                var objActual = myThis.mythis.griglia.instance.getController("editing");
                                var actualData=objActual._dataController._items[0]['data'];
                                objActual._dataController._items[0]['data'][colonna.lookup.related[0].dataField]='' //OK
                                rowData[colonna.lookup.related[0].dataField] = ''
                                }
                        }
                        colonna=relatedColumn;
                    }
                    else colonna=null
  
            }
     */
        //if(value[colonnax[0].lookup.valueExpr])
        // value=value[colonnax[0].lookup.valueExpr];
        (<any>this).defaultSetCellValue(rowData, value);
        let e: any = {};

        let masterThis = eval("findmasterThis();");
        e.name = "setCellValue";
        e.rowData = rowData;
        e.value = value;
        e.dataField = this.dataField;
        e.masterThis = masterThis;
        masterThis.onAllEvent.emit(e);
        rowData = e.rowData;
    }

    // onSelectionChanged(selectedRowKeys, cellInfo, dropDownBoxComponent, xx, k) {
    // 	////////console.log("onSelectionChanged ",cellInfo.data.versione);
    // 	////////console.log("onSelectionChanged ",k);

    // 	return;
    // 	if (selectedRowKeys.length == 0) {
    // 		return;
    // 	}
    // 	cellInfo.setValue(selectedRowKeys[0][this.masterKey]);
    // 	if (selectedRowKeys.length > 0) {
    // 		dropDownBoxComponent.close();
    // 	}
    // 	////////console.log(cellInfo)
    // }
    onListSelectionChanged(e) {
        console.log("wwwwwwwwwwwwww ", e);
    }

    onSelectionChangedDue(selectedRowKeys, cellInfo, dropDownBoxComponent) {
        ////////console.log('cambio look', selectedRowKeys);
        //    ////////console.log("wwwwwwwwwwwwwwwwwwwwww ",dropDownBoxComponent);
        /*if(selectedRowKeys.length == 0){
        return
    }
 cellInfo.setValue(selectedRowKeys[0]);
    if(selectedRowKeys.length > 0) {
            dropDownBoxComponent.close();
    }
    ////////console.log(cellInfo)*/
    }
    cellTemplate(container, options) {
        var noBreakSpace = "\u00A0",
            text = (options.value || [])
                .map((element) => {
                    return options.column.lookup.calculateCellValue(element);
                })
                .join(", ");
        container.textContent = text || noBreakSpace;
        container.title = text;
    }
    ngAfterViewInit() {
        this.getWindowHeight();
        if (!this.name) this.name = "";
        if (this.gridHeight > 0) {
            // ! RIMOSSO PERCHE SOVRASCIVE TUTTE LE DIVERSE INSTANZE DI UNA VISTA ALL'ULTIMA CARICATA
            /* let elementGrid = null;
            if (this.name) {
                 let xx = this.name.replace(/[ ]/g, '');
                 elementGrid = $('#grigliaMaster [name=' + xx + ']');
            }
            if (elementGrid) {
                 $(elementGrid).height(this.gridHeight + 'px');
                 $(elementGrid).css('height', this.gridHeight + 'px');
            } else {
                 $('#grigliaMaster').height(this.gridHeight + 'px');
                 $('#grigliaMaster').css('height', this.gridHeight + 'px');
            } */
        }
        //let dove = "[name='" + this.name + "']" + ' .dx-datagrid-header-panel';
        // ok $('[role="toolbar"]').append('<div><button type="button">Azione</button></div>');
        let dove =
            "[name='" + this.name + "']" + " .dx-toolbar-items-container";
        // Rimuove qualsiasi div con classe "testo-griglia"
        $(dove).find('.testo-griglia').remove();

        // Aggiunge il titolo solo se non è già presente nel testo complessivo
        if (!$(dove).text().includes(this.titoloGriglia)) {
            $(dove).append(`<div class="testo-griglia">${this.titoloGriglia}</div>`);
        }
        //this.changeTitoloGriglia(this.titoloGriglia)
        //$(dove).append("<p class='titologriglia griglia-title'>"+'this.titoloGriglia'+'</p>');;
        $(".grigliaMaster .dx-datagrid-search-panel").width("98%");
    }
    changeTitoloGriglia(testo: any) {
        let dove =
            "[name='" + this.name + "']" + " .dx-toolbar-items-container ";
        var primoP = $(dove).find(".testo-griglia").first();
        $(primoP).html(testo);
    }
    onValueChanged(args, setValueMethod) {
        setValueMethod(args.value);
    }
    getWindowHeight() {
        if (this.asDetail) {
            this._height = undefined;
        } else {
            this._height = (window.screen.height / 100) * 70;
            //this._height = "100%"
        }
        this.cdref.detectChanges();
    }
    onRowUpdating(e: any) {
        e.name = "onRowUpdating";
        e.componentName = this.name;
        this.onAllEvent.emit(e);
    }

    onInitNewRow(e: any) {
        if (this.modeEdit == "customComponent") {
            e.cancel = true;
            this.selezionaRiga(e.data[this.masterKey]);
            const anagraficaFilter = this.configurationService; //this.datiGriglia.filter(r => r.configuration);
            let instanceData;
            // Verifica se la proprietà 'configuration' si trova direttamente nel primo oggetto dell'array
            if (anagraficaFilter[0] && anagraficaFilter[0]["configuration"]) {
                instanceData = anagraficaFilter[0]["configuration"];
            }
            // Se non la troviamo, verifica se 'configuration' si trova nel primo oggetto dentro un'altra struttura
            else if (
                anagraficaFilter[0] &&
                Object.keys(anagraficaFilter[0]).length > 0
            ) {
                Object.keys(anagraficaFilter[0]).forEach((key) => {
                    if (key === "configuration") {
                        instanceData = anagraficaFilter[0][key];
                    }
                });
            }
            let serviceData = this.dati.getService(this.service);
            if (serviceData[0]) {
                if (
                    Object.keys(serviceData[0]).length === 1 &&
                    serviceData[0].hasOwnProperty("configuration")
                ) {
                    serviceData.splice(0, 1);
                } else if (serviceData[0].hasOwnProperty("configuration")) {
                    delete serviceData[0].configuration;
                }
            }
            e["serviceData"] = serviceData;
            /*          e['serviceName'] = this.service; */
            e["serviceConfiguration"] = instanceData;
            e.component.cancelEditData();
            this.onAllEvent.emit(e);
            return;
        }
        if (this.modeEdit == "nicaform") {
            e.cancel = true;
            const formActionType = "insert";
            this.OpenExternalEditor(e, formActionType);
            setTimeout(() => {
                e.component.cancelEditData();
            }, 300);

            return;
        }
        if (this.modeEdit == "nicaforminternal") {
            e.cancel = true;
            //this.OpenInternalEditor(e);
            return;
        }

        this.dataRowSelected = [];
        this.isEditing = false;
        this.isNewRecord = true;
        if (this.datiGriglia != undefined) {
            this.datiGriglia.forEach((element, i) => {
                if (element.componentType) {
                    this.editorTabDisabled[element.componentType] = true;
                }

                if (element.itemType == "group") {
                    element.data.forEach((element) => {
                        if (element.defaultValue)
                            e.data[element.dataField] = element.defaultValue;
                        else if (element.dataType == "boolean")
                            e.data[element.dataField] = false;
                    });
                }
            });
        }
        //-------------------------------------------------
        let founds = this.returnDynamicComponent();
        this.currentRow = {};
        if (founds > "") this.instanceComponent(founds);
        //--------------------------------------------------
        e.name = "onInitNewRow";
        //e.component.cancelEditData();
        //window.setTimeout(function () { e.component.cancelEditData(); }, 0)
        //return;
        e.componentName = this.name;
        e.masterComponent = this;
        e.masterThis = this;
        this.onAllEvent.emit(e);

        this.titoloPopUp = this.titolo + " (Nuovo) ";
        ////////console.log("Init New Row");
        ////////console.log(e);
        this.isEditing = false;
        ////////console.log("In nuova riga a false");
        return e;
    }

    OpenExternalEditor(e, formActionType) {
        /*
    @Input() SubjectCall: string;   // Richiama il service per costrure la form
    @Input() ApiCall: string;      // Chiamata api per ottenere i dati
    @Input() filterKey: string;   // url filter delle api (ES.Id IDSoggetto) 
  
    @Input() queryString: string;  // Query String (?nomecampo={{valore}})tabella come da istruzioni Swagger 
    @Input() itemData             // dati passati quando viene richiamato il form in EntryComponent
    @Input() dataJson: any[];   // Passa il json con i dati anziche richimare l'api
    @Input() type: any   // per visualizzare la form suddifica in tab è false di default tabbed || tabbedStep || simpleForm(per form semplice)
    @Input() nCol: any
    @Input() heightForm: number //altezza form
    @Input() CustomButtonSetForm  // Bottoni Custom per eventi esterni 
    @Input() disableEditForm: boolean  // Abilita salvataggio del FORM da componente se FALSE di solalettura
 
    @Input() toolbarTop: boolean = false
    @Input() toolbarBottom: boolean = false
  
    */

        //this._overlaySidePanelService.setTitle("Contatti Soggetto "+SoggettoSelezionato.ragioneSociale);

        //--------------------------------------

        /*       const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
                    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'NewNicaFormComponent'); */

        /*       const api_rest = anagraficaFilter[0]['configuration']['api_rest'];
                    const apiset = anagraficaFilter[0]['configuration']['api'];
                    const SubjectCall = anagraficaFilter[0]['configuration']['service'];
                    const type = anagraficaFilter[0]['configuration']['formType'];
                    const nCol = anagraficaFilter[0]['configuration']['nCol']; */
        /*
                    let queryString;
                    let filterEditor = anagraficaFilter[0]['configuration']['filterEditor'];
                    let masterKey = anagraficaFilter[0]['configuration']['masterKey']
                  
                    if (filterEditor.includes('$')) {
      
                         if (data.id != '' && typeof data.id != 'undefined') {
                                queryString = filterEditor.replace('$', data.id);
      
                                isEdit = true;
                         } else if (data[masterKey] != '' && typeof data[masterKey] != 'undefined') {
                                queryString = filterEditor.replace('$', data[masterKey]);
                                isEdit = true;
                         }
                    } */
        //!--------------------------------------------------------------------------------------------------------
        const anagraficaFilter = this.configurationService; //this.datiGriglia.filter(r => r.configuration);
        let positionPopUp = "top";
        let widthPopUp = null;
        if (anagraficaFilter[0]["configuration"]["positionPopUp"]) {
            positionPopUp =
                anagraficaFilter[0]["configuration"]["positionPopUp"];
        }
        if (anagraficaFilter[0]["configuration"]["widthPopUp"]) {
            widthPopUp = anagraficaFilter[0]["configuration"]["widthPopUp"];
        }
        let data = JSON.parse(JSON.stringify(e.data));
        let isEdit = false;
        if (this.costantValues) {
            this.costantValues.forEach((element) => {
                data = { ...data, [element["key"]]: element["value"] };
            });
        }
        let instanceData: { [key: string]: any } = {};
        // Verifica se la proprietà 'configuration' si trova direttamente nel primo oggetto dell'array
        if (anagraficaFilter[0] && anagraficaFilter[0]["configuration"]) {
            instanceData = anagraficaFilter[0]["configuration"];
        }
        // Se non la troviamo, verifica se 'configuration' si trova nel primo oggetto dentro un'altra struttura
        else if (
            anagraficaFilter[0] &&
            Object.keys(anagraficaFilter[0]).length > 0
        ) {
            Object.keys(anagraficaFilter[0]).forEach((key) => {
                if (key === "configuration") {
                    instanceData = anagraficaFilter[0][key];
                }
            });
        }
        if (anagraficaFilter[0] && anagraficaFilter[0]["configuration"]) {
            Object.keys(anagraficaFilter[0]["configuration"]).forEach((key) => {
                if (key === "filterEditor") {
                    if (
                        anagraficaFilter[0]["configuration"][key].includes("$")
                    ) {
                        if (data.id != "" && typeof data.id != "undefined") {
                            anagraficaFilter[0]["configuration"][
                                "queryString"
                            ] = anagraficaFilter[0]["configuration"][
                                key
                            ].replace("$", data.id);
                            isEdit =
                                anagraficaFilter[0]["configuration"][
                                    "isEdit"
                                ] !== undefined
                                    ? anagraficaFilter[0]["configuration"][
                                    "isEdit"
                                    ]
                                    : true;
                        } else if (
                            data[
                            anagraficaFilter[0]["configuration"][
                            "masterKey"
                            ]
                            ] != "" &&
                            typeof data[
                            anagraficaFilter[0]["configuration"][
                            "masterKey"
                            ]
                            ] != "undefined"
                        ) {
                            anagraficaFilter[0]["configuration"][
                                "queryString"
                            ] = anagraficaFilter[0]["configuration"][
                                key
                            ].replace(
                                "$",
                                data[
                                anagraficaFilter[0]["configuration"][
                                "masterKey"
                                ]
                                ]
                            );
                            isEdit =
                                anagraficaFilter[0]["configuration"][
                                    "isEdit"
                                ] !== undefined
                                    ? anagraficaFilter[0]["configuration"][
                                    "isEdit"
                                    ]
                                    : true;
                        }
                    }
                }
            });
        }
        if (anagraficaFilter[0]["configuration"]["costantValues"]) {
            anagraficaFilter[0]["configuration"]["costantValues"].forEach(
                (element: costantValue) => {
                    /* if (element.value === 'UtenteLoggato') {
					data[element.key] = this.utenteSerivce.InfoDatiUtenteConnesso.nomeCompleto || ''
					return
				}  */ if (element.value === "DataOggi") {
                        data[element.key] = new Date();
                        return;
                    }
                }
            );
        }
        if (this.isDataStatic && this.isStatic) {
            instanceData["api"] = "";
            instanceData["remoteOperation"] = false;
            isEdit = false;
        }
        Object.assign(instanceData, { isEdit: isEdit });
        Object.assign(instanceData, { dataJson: data });
        Object.assign(instanceData, { formActionType: formActionType });
        console.log(instanceData);
        let titoloPopup = "";
        if (this.titoloPopUp) titoloPopup = this.titoloPopUp;
        else titoloPopup = this.titoloGriglia;

        const width = widthPopUp;
        let guid = Math.random().toString().replace("0.", "");
        this.userComponentService.setNewPopUp(
            guid,
            "NewNicaFormComponent",
            false,
            width,
            null,
            instanceData,
            false,
            true,
            titoloPopup,
            positionPopUp
        );

        this.userComponentService.outputComponent.subscribe((currentOutput) => {
            //console.log(currentOutput)
            if (currentOutput.name == "submittedEditOk" && currentOutput.guid == guid) {
                this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
                this.userComponentService.destroyOutputComponent();
                this.refresh();
                this.onAllEvent.emit(currentOutput);
                return;
            }

            if (currentOutput.name === "submitFormStatic" && currentOutput.guid == guid) {
                if (currentOutput.submitType === "edit") {
                    if (this.isStatic || this.isDataStatic) {
                        if (this.masterKey && this.masterKey !== "") {
                            const indice = this.myDsStatic.findIndex(
                                (obj) =>
                                    obj[this.masterKey] ===
                                    currentOutput.data[this.masterKey]
                            );
                            if (indice !== -1) {
                                this.myDsStatic[indice] = currentOutput.data;
                            } else {
                                console.error("errore master key");
                            }
                        }
                        currentOutput.newSet = this.myDsStatic;
                        currentOutput.dataFieldForm = this.dataFieldForm;
                    }
                    //               console.log(this.myDsStatic)
                    this.onAllEvent.emit(currentOutput);
                    return
                } else if (currentOutput.submitType === "insert") {
                    if (this.isDataStatic || this.isStatic) {
                        this.myDsStatic = this.myDsStatic.filter(
                            (x) => x.__KEY__ !== currentOutput.data.__KEY__
                        );
                        this.myDsStatic.push(currentOutput.data);
                        currentOutput.newSet = this.myDsStatic;
                        currentOutput.dataFieldForm = this.dataFieldForm;
                        //               console.log(currentOutput)
                        //               console.log(this.myDsStatic)
                        this.onAllEvent.emit(currentOutput);
                    }
                }
                this.userComponentService.destroyCurrentOpenPopUpByGuid(
                    currentOutput.guid
                );
                this.onAllEvent.emit(currentOutput);
                this.userComponentService.destroyOutputComponent();
                this.refresh();
                return;
            }

            if (currentOutput.name == "submittedInsertOk" && currentOutput.guid == guid) {
                setTimeout(() => {
                    if (this.griglia)
                        (this.griglia.instance as any).cancelEditData();
                    this.refresh();
                }, 100);

                this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
                this.userComponentService.destroyOutputComponent();
                //this.refresh();
                this.onAllEvent.emit(currentOutput);
                return;
            }
            if (currentOutput.name == "return" && currentOutput.guid == guid) {
                setTimeout(() => {
                    if (this.griglia)
                        (this.griglia.instance as any).cancelEditData();
                    this.refresh();
                }, 50);

                this.userComponentService.destroyCurrentOpenPopUpByGuid(
                    currentOutput.guid
                );
                this.onAllEvent.emit(currentOutput);
                this.userComponentService.destroyOutputComponent();
                return;
            }

        });
        return;
        //!--------------------------------------------------------------------------------------------------------
        /*       let dataToSend = [
                         {
                                SubjectCall: SubjectCall,
                                ApiCall: apiset,
                                filterKey: data.id,
                                queryString: queryString,
                                dataJson: data,
                                type: type,
                                nCol: nCol,
                                disableEditForm: false,
                                toolbarTop: false,
                                toolbarBottom: true,
                         },
                    ];
      
                    let titoloOverlay = '';
                    if (this.titoloPopUp) titoloOverlay = this.titoloPopUp;
                    else titoloOverlay = this.titoloGriglia;
      
                    this._overlaySideFormService.setTitle(titoloOverlay);
                    this._overlaySideFormService.setContent(factoryClass);
                    this._overlaySideFormService.sendDataToComponent(dataToSend);
                    this._overlaySideFormService.setPopupWidth(this.widthPopUpEdit);
                    this._overlaySideFormService.setPopupHeight(this.heightPopUpEdit);
                    setTimeout(() => {
                         //isPopUp
                         this._overlaySideFormService._hrefComponent.instance.isPopUp = true;
                         this._overlaySideFormService._hrefComponent.instance.heightForm = this.widthPopUpEdit;
                         this._overlaySideFormService._hrefComponent.instance.class = 'soggetto-form';
                         (this._overlaySideFormService._hrefComponent.instance.emittendButtonPush as EventEmitter<any>).subscribe((res) => {
                                console.log('Ecco evento della form XXXX', res);
                                //"onValueChange"
                                if (res.eventName == 'submittedEditOk') {
                                     this._overlaySideFormService.close();
      
                                     this.refresh();
                                     return;
                                }
                                if (res.eventName == 'submittedInsertOk') {
                                     this._overlaySideFormService.close();
                                     setTimeout(() => {
                                            if (this.griglia) (this.griglia.instance as any).cancelEditData();
                                            this.refresh();
                                     }, 100);
      
                                     //this.refresh();
                                     return;
                                }
                                if (res.name == 'return') {
                                     this._overlaySideFormService.close();
      
                                     setTimeout(() => {
                                            if (this.griglia) (this.griglia.instance as any).cancelEditData();
                                            this.refresh();
                                     }, 50);
      
                                     return;
                                }
                                if (res.name) {
                                     this.onAllEvent.emit(res);
                                     //this.refresh();
                                     return;
                                }
                                if(res.name == 'onValueChange' || res.name=='valueDifferent'){
                                 this.onAllEvent.emit(res)
                                 this.refresh();
                                 return;           
                            }
                         });
                    }, 500);
                    this._overlaySideFormService.show(); */
    }

    disableCustomButton(id, flag) {
        // Trova l'istanza della griglia

        //let toolbarItems = this.griglia.instance. toolba toolbarOptions.items;
        // let allElm = document.querySelectorAll(".dx-state-selected");
        let p = document.querySelectorAll("#" + id);
        p.forEach((el) => {
            if (!flag) el.classList.remove("dx-state-disabled");
            else el.classList.add("dx-state-disabled");
        });
        return;

        //this.mythis.griglia.instance
        // Recupera i pulsanti dalla toolbar
        const grid = this.griglia.instance;

        // Disabilita i pulsanti personalizzati
        grid.option("toolbar.items[3].options.disabled", true); // Aggiungi
        grid.option("toolbar.items[4].options.disabled", true); // Rimuovi

        grid.repaint(); // Rende effettivo il cambiamento
    }
    onEditorPreparedDetail(e) {
        if (isArray(e.detailRif)) {
            if (e.detailRif[0]["defaultFormDisabled"] === true) {
                e.cancel = true;
            }
        }
        let evento = e;
        if (typeof e === "object") {
            e.masterThis = this; //eval("findmasterThis();")
            e.keyEspansa = this.keyEspansa;
        } else {
            evento = {
                name: e,
                masterThis: this,
                keyEspansa: this.keyEspansa,
            };
        }
        this.onAllEvent.emit(evento);
    }

    inizializza(data: any) {
        this.api = data[0].api;
        this.service = data[0].service;
        this.tipoSelezione = data[0].tipoSelezione;
        this.name = data[0].name;
        /*
    this.aggiungi = data[0].aggiungi;
    this.modifica = data[0].modifica;
    this.elimina = data[0].elimina;
    */
    }

    onEditorPrepared(e) {
        //alert("wwwwwwwwwwwwww","wwwwwwwwwwwwwwwwww")
        this.currentRow = e.data;

        this.currentKey = e.key;
        this.refreshAllRelation(this.currentRow);
        //console.log("Ecco il record prima di edit ",this.currentRow)
        //Dovrei cercare tutti i component creati ed inizializzarli al valore
        //this.spinner.show();

        //var modifiedValues = this.mythis.griglia.instance.getController("editing");//._editData[0].data;
        //var modifiedValuess = this.mythis.griglia.instance.getEditor("IDCER");//._editData[0].data;
        //var modifiedValuess = this.mythis.griglia.instance//.set   getEditor("IDCER");//._editData[0].data;

        //console.log("Ecco instance", modifiedValuess);
        //console.log("Ecco editor", modifiedValues);

        /*  var objActual = this.mythis.griglia.instance.getController("editing");
        var actualData = objActual._dataController._items[0]['data'];
        //console.log("Ecco i dati della griglia objActual", objActual);
        //console.log("Ecco i dati della griglia actualData", actualData);
        objActual._dataController._items[0]['data']['IDCER']='banana' //OK 
        */

        //-------------------------------------------------

        //--------------------------------------------------

        let founds = this.returnDynamicComponent();
        if (founds > "") this.instanceComponent(founds);

        this.isEditing = false;
        this.isNewRecord = false;

        if (e.data) {
            this.editorTabDisabled = [];
        }

        ////console.log("ugo")
        this.dataRowSelected = e.data;
        ////console.log("ugo1")
        e.name = "onEditorPrepared";
        e.masterThis = this; //eval("findmasterThis();")
        e.masterComponent = e.component;
        e.componentName = e.masterThis.name;
        // //console.log("ugo2")

        if (this.defaultFormDisabled == true) {
            e.cancel = true;
        }

        if (this.modeEdit == "nicaform") {
            e.cancel = true;
            //console.log(e)
            this.selezionaRiga(e.data[this.masterKey]);
            /*          const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
                             //////console.log("Ecco i componenti ",factories);
                             const factoryClass = <Type<any>>factories.find((x: any) => x.name === this.modeEditComponent); */
            //////console.log("Ecco i factoryClass ",factoryClass);
            const formActionType = "edit";
            this.OpenExternalEditor(e, formActionType);
        }

        if (this.modeEdit == "customComponent") {
            e.cancel = true;
            this.selezionaRiga(e.data[this.masterKey]);
            const anagraficaFilter = this.configurationService; //this.datiGriglia.filter(r => r.configuration);
            let instanceData;
            // Verifica se la proprietà 'configuration' si trova direttamente nel primo oggetto dell'array
            if (anagraficaFilter[0] && anagraficaFilter[0]["configuration"]) {
                instanceData = anagraficaFilter[0]["configuration"];
            }
            // Se non la troviamo, verifica se 'configuration' si trova nel primo oggetto dentro un'altra struttura
            else if (
                anagraficaFilter[0] &&
                Object.keys(anagraficaFilter[0]).length > 0
            ) {
                Object.keys(anagraficaFilter[0]).forEach((key) => {
                    if (key === "configuration") {
                        instanceData = anagraficaFilter[0][key];
                    }
                });
            }
            let serviceData = this.dati.getService(this.service);
            if (serviceData[0]) {
                if (
                    Object.keys(serviceData[0]).length === 1 &&
                    serviceData[0].hasOwnProperty("configuration")
                ) {
                    serviceData.splice(0, 1);
                } else if (serviceData[0].hasOwnProperty("configuration")) {
                    delete serviceData[0].configuration;
                }
            }
            e["serviceData"] = serviceData;
            /*          e['serviceName'] = this.service; */
            e["serviceConfiguration"] = instanceData;
        }

        if (typeof this.validateFieldPrepared == "function") {
            this.validateFieldPrepared(e);
        }

        //console.log("ugo3")
        this.immagine = [];
        setTimeout(() => {
            this.colonneGriglia.forEach((element, i) => {
                if (element.type == "image") {
                    this.immagine[i] = e.data[element.dataField];
                }
                if (
                    element.disableOnUpdate === true &&
                    this.isNewRecord == false
                ) {
                    this.myDSdisbleField[element.prog] = true;
                } else this.myDSdisbleField[element.prog] = false;
            });
        }, 100);

        this.onAllEvent.emit(e);
    }
    onContentPopUpReady(e) {
        alert("wwwwwwwwwwwww", "eeeeeeeeeeeee");
        var contentElement = e.component.content();
        contentElement.style.padding = "30px";
    }
    onRowPreparig(e) {
        e.name = "onRowPreparig";
        e.componentName = this.name;
        e.masterThis = this;
        this.onAllEvent.emit(e);
    }
    onRowPrepared(e) {
        e.name = "onRowPrepared";
        e.componentName = this.name;
        e.masterThis = this;
        this.onAllEvent.emit(e);

        if (e.rowType == "filter") {
        }
        if (e.rowType == "data") {

            //let allElm = document.querySelectorAll(".dx-datagrid-group-closed");
            //e.rowElement.find(".dx-datagrid-group-closed").append("<i class='fa fa-plus' aria-hidden='true''></i>")
            //e.rowElement.find(".dx-datagrid-group-opened").append("<i class='fa fa-minus' aria-hidden='true''></i>")
            // e.name="onRowPrepared";
            // e.componentName=this.name;
            // this.onAllEvent.emit(e);
        }
        if (e.rowType == "header") {
        }
    }
    Cambio() {
        alert("asdadasda", "dafdsfssfd");
    }

    calculateCellValue(e) {
        //console.log('calculateCellValue ',e);
        //const column = this as any;
        //e.eer=e.eer+"*"
        //return column.defaultCalculateCellValue(e);
        //return rowData.firstName + " " + rowData.lastName;
    }

    onEditingStart(e) {
        if (e.dataField == "per") return;

        //this.currentRow = e.data;
        //if(!e.dataField)
        ////console.log("e.parentType",e.parentType)
        // alert("wwwww","wwwww")

        if (e.parentType == "dataRow") {
            //alert("wwwww","wwwww")
            //////console.log("xxxxxxxxxxxxxxxxxxxx ",e)
            //this.selezionaRiga(e.row.data[this.masterKey]);
        }

        this.titoloPopUp = this.titolo; //+" (Modifica) ";
        this.masterThis.isEditing = true;

        if (e.parentType == "dataRow" && e.dataField == "descrizione") {
            //this.fnInstnce[e.dataField] = e
            //////console.log("fnInstnceeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee ",e);
            // this.fnInstnce['descrizione'] = e.editorElement;
            //////console.log("fnInstnceeeeeeeeeeeee ",this.fnInstnce);
        }

        //////console.log("In On content messo a true");
        //if(!e.component.hasEditData())
        //         this.isEditing = false;

        //alert(this.masterThis.isEditing,"onEdit");
        e.name = "onEditingStart";
        e.componentName = this.name;
        e.masterThis = this;
        ////console.log("ffffffffffffffffffffffv ",e)
        ////console.log("ffffffffffffffffffffffv ",e.parentType)
        this.onAllEvent.emit(e);
        if (typeof this.validateEdit == "function") {
            this.validateEdit(e);
        }
    }
    preparaToolbar(e) {
        //////console.log("MALEDETTO",e);
        const that = this;
        //

        //----------------------- Intecetta click su new record ---------------------------------------------------
        let toolbarItems = e.toolbarOptions.items;

        let columnChooserButton = toolbarItems.find(
            (x) => x.name === "columnChooserButton"
        );

        if (columnChooserButton)
            if (columnChooserButton.options) {
                columnChooserButton.options.icon = "export icon-column-chooser";
                columnChooserButton.options.elementAttr = {
                    class: "iconeToolbar",
                };
            }

        let addRowButton = toolbarItems.find((x) => x.name === "addRowButton");
        let risp = null;

        if (this.hideToolBar) {
            const toolBarVisible = false;
            e.toolbarOptions.visible = toolBarVisible;
        }

        if (addRowButton) {
            addRowButton.showText = "always";

            if (this.customAddRowButton) {
                if (this.customAddRowButton.text)
                    addRowButton.options.text = this.customAddRowButton.text;
                else addRowButton.options.text = "Nuovo";

                if (this.customAddRowButton.icon) {
                    addRowButton.options.icon = this.customAddRowButton.icon;
                    addRowButton.options.hint = "";
                } else addRowButton.options.icon = "export icon-plus-circled"; //devextreme: 'plus'

                if (this.customAddRowButton.hint)
                    addRowButton.options.hint = this.customAddRowButton.hint;
            } else {
                addRowButton.options.text = this.TextAddRowButton;
                addRowButton.options.icon = "export icon-plus-circled"; //devextreme: 'plus'
            }

            if (this.cssClassAddRowButton)
                addRowButton.options.elementAttr = {
                    class: this.cssClassAddRowButton,
                };
            else
                addRowButton.options.elementAttr = {
                    class: "my-class-buttonAdd-grid iconeToolbar",
                };

            addRowButton.options.onClick = ($event) => {
                $event.name = "onInitNewRow";
                $event.cancel = false;
                e.componentName = this.name;
                $event.masterComponent = this;
                $event.dxGridComponent = this.griglia.instance;
                risp = this.onAllEvent.emit($event);
                if (risp) $event = risp;
                //////console.log("MYDS ",that.griglia);
                if (!$event.cancel) that.griglia.instance.addRow();
            };
        }

        //-----------------------------------------------------------------------------
        if (this.isExportExcelAvailable) {
            e.toolbarOptions.items.unshift(
                this.isAdvancedXlsExportAvailable == true
                    ? {
                        location: "after",
                        widget: "dxDropDownButton", //'dxDropDownButton',
                        //cssClass:'container',
                        elementAttr: {
                            title: "Esporta in Xlsx",
                            class: "iconeToolbar",
                        },
                        options: {
                            icon: "export icon-file-excel", // 'assets/icons/ExcelExport.svg'
                            showArrowIcon: false,
                            displayExpr: "text",
                            keyExpr: "value",
                            //itemTemplate:'elementi',
                            cssClass: "tastoExportGriglia",
                            elementAttr: {
                                title: "Esporta in Xlsx",
                                class: "iconeToolbar",
                            },

                            dropDownOptions: {
                                width: 290,
                                height: 60,
                            },
                            //stylingMode: 'text',
                            //useSelectMode:true,
                            onClick: async () => {
                                //that.griglia.instance.exportToExcel(false);
                                await this.esportaXls(
                                    this.griglia.instance,
                                    false
                                );
                            },
                            items: [
                                {
                                    value: 1,
                                    text: "Esporta Dati Visualizzati",
                                },
                                {
                                    value: 2,
                                    text: "Esportazione Avanzata",
                                },
                                /*
      {
       template: this.customMarkup
      }
      */
                            ],

                            itemTemplate: function (data, index, element) {
                                //////console.log(data);
                                //////console.log(element);
                                //element.setAttribute('class','container');
                                //element.style.borderStyle = 'dotted';
                                element.style.margin = "0px";
                                element.title = "";

                                if (index === 0)
                                    element["innerHTML"] =
                                        '<span style="display:flex;flex-direction:row;align-items:center;" title=""><i style="font-size:18px;padding-right:5px" class="export icon-file-excel"></i>' +
                                        `${data["text"]}</span>`;
                                if (index === 1)
                                    element["innerHTML"] =
                                        '<span style="display:flex;flex-direction:row;align-items:center" title=""><i style="font-size:18px;padding-right:5px;color: #023957;" class="icon export icon-column"></i>' +
                                        `${data["text"]}</span>`; //dx-icon-exportselected

                                return element;
                            },

                            onItemClick: async function (e) {
                                //////console.log(e);

                                if (e.itemData["value"] === 1) {
                                    let selectedRowsData =
                                        that.griglia.instance.getSelectedRowsData();

                                    if (selectedRowsData.length > 0) {
                                        // Se ci sono righe selezionate, esporta solo quelle
                                        await that.esportaXls(
                                            that.griglia.instance,
                                            true
                                        );
                                    } else {
                                        // Se non ci sono righe selezionate, esporta tutte le righe
                                        await that.esportaXls(
                                            that.griglia.instance,
                                            false
                                        );
                                    }

                                    return;
                                } else if (e.itemData["value"] === 2) {
                                    //that.areRigheSelezionate = true;
                                    //that.griglia.instance.exportToExcel(false);
                                    that.onAllEvent.emit({
                                        name: "AperturaExcelAvanzato",
                                    });
                                    that.pannelloEsportaExcelAdvanced = true;

                                    /*
       setTimeout(
           ()=>{
               that.excelExporter.emettiClick.subscribe(
                   (colonne)=>{
                       //console.log(colonne);
                   }
               );
           },1000
       )*/

                                    return;
                                }
                            },
                        },
                    }
                    : {
                        location: "after",
                        widget: "dxButton", //'dxDropDownButton',
                        //cssClass:'container',
                        options: {
                            icon: "export icon-file-excel", // 'assets/icons/ExcelExport.svg',  //'xlsxfile',
                            showArrowIcon: false,
                            displayExpr: "text",
                            keyExpr: "value",
                            //itemTemplate:'elementi',
                            cssClass: "tastoExportGriglia",
                            elementAttr: {
                                title: "Esporta in Xlsx",
                                class: "iconeToolbar",
                            },

                            onClick: async () => {
                                await this.esportaXls(
                                    that.griglia.instance,
                                    that.griglia.instance.getSelectedRowsData()
                                        .length > 0
                                );

                                /*
                              let selectedRowsData =that.griglia.instance.getSelectedRowsData();
                              //that.griglia.instance.exportToExcel(that.griglia.instance.getSelectedRowsData().length>0);
                              console.log(selectedRowsData)
                              if (selectedRowsData.length > 0) {
                                   // Se ci sono righe selezionate, esporta solo quelle
                                   console.log('Esportazione delle righe selezionate:', selectedRowsData);
                                   that.griglia.instance.exportToExcel(true);
                              } else {
                                   // Se non ci sono righe selezionate, esporta tutte le righe
                                   console.log('Nessuna riga selezionata. Esportazione di tutte le righe.');
                                   that.griglia.instance.exportToExcel(false);
                              }*/
                            },
                        },
                    }
            );
        }

        if (this.showResetFilterColumn) {
            e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton", //'dxDropDownButton',
                //cssClass:'container',
                options: {
                    icon: "export icon-remove-filter", //'assets/icons/DocxExport.svg' 'docxfile'
                    showArrowIcon: false,
                    displayExpr: "text",
                    keyExpr: "value",
                    //itemTemplate:'elementi',
                    cssClass: "tastoResetFilter",
                    elementAttr: {
                        title: "Resetta Filtri",
                        class: "iconeToolbar tastoResetFilter",
                    },
                    //stylingMode: 'text',
                    //useSelectMode:true,
                    onClick: () => {
                        this.resetFilter()
                    },
                },
            });
        }
        if (this.isExportDocxAvailable) {
            e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton", //'dxDropDownButton',
                //cssClass:'container',
                options: {
                    icon: "export icon-file-word", //'assets/icons/DocxExport.svg' 'docxfile'
                    showArrowIcon: false,
                    displayExpr: "text",
                    keyExpr: "value",
                    //itemTemplate:'elementi',
                    cssClass: "tastoExportGriglia",
                    elementAttr: {
                        title: "Esporta in Docx",
                        class: "iconeToolbar",
                    },

                    dropDownOptions: {
                        width: 290,
                        height: 60,
                    },
                    //stylingMode: 'text',
                    //useSelectMode:true,
                    onClick: () => {
                        that.stampaFile(true);
                    },
                    items: [
                        {
                            value: 1,
                            text: "Esporta tutti i dati",
                        },
                        {
                            value: 2,
                            text: "Esporta le righe selezionate",
                        },
                    ],

                    itemTemplate: function (data, index, element) {
                        //////console.log(data);
                        //////console.log(element);
                        //element.setAttribute('class','container');
                        //element.style.borderStyle = 'dotted';
                        element.style.margin = "0px";
                        element.title = "";

                        if (index === 0)
                            element["innerHTML"] =
                                '<span style="display:flex;flex-direction:row;align-items:center;" title=""><i style="font-size:18px;padding-right:5px" class="icon dx-icon-docxfile"></i>' +
                                `${data["text"]}</span>`;
                        if (index === 1)
                            element["innerHTML"] =
                                '<span style="display:flex;flex-direction:row;align-items:center" title=""><i style="font-size:18px;padding-right:5px" class="icon dx-icon-exportselected"></i>' +
                                `${data["text"]}</span>`;

                        return element;
                    },

                    onItemClick: async function (e) {
                        //////console.log(e);

                        if (e.itemData["value"] === 1) {
                            //alert('Funzione ancora in sviluppo!','Attenzione');

                            that.stampaFile(true);

                            //that.stampaPdf(e);
                        } else {
                            //alert('Funzione ancora in sviluppo!','Attenzione');

                            that.stampaFileRigheSelezionate(true);
                        }
                    },
                },
            });
        }
        if (this.isExportPDFAvailable == true) {
            e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton", //'dxDropDownButton',
                //cssClass:'container',
                options: {
                    icon: "export icon-file-pdf", //'pdffile'
                    displayExpr: "text",
                    keyExpr: "value",
                    //itemTemplate:'elementi',
                    elementAttr: {
                        title: "Anteprima PDF",
                        class: "iconeToolbar",
                    },
                    onInitialized: (args: any) => {
                        this.btnExportInstance = args.component;
                    },
                    dropDownOptions: {
                        width: 290,
                        height: 60,
                    },
                    //stylingMode: 'text',
                    //useSelectMode:true,
                    onClick: () => {
                        that.stampaFile();
                    },
                    items: [
                        {
                            value: 1,
                            text: "Anteprima di tutti i dati",
                        },
                        {
                            value: 2,
                            text: "Anteprima delle righe selezionate",
                        },
                        /*
                {
                 template: this.customMarkup
                }
                */
                    ],

                    itemTemplate: function (data, index, element) {
                        //////console.log(data);
                        //////console.log(element);
                        //element.setAttribute('class','container');
                        //element.style.borderStyle = 'dotted';
                        element.style.margin = "0px";
                        element.title = "";

                        if (index === 0)
                            element["innerHTML"] =
                                '<span style="display:flex;flex-direction:row;align-items:center;" title=""><i style="font-size:18px;padding-right:5px" class="icon dx-icon-pdffile"></i>' +
                                `${data["text"]}</span>`;
                        if (index === 1)
                            element["innerHTML"] =
                                '<span style="display:flex;flex-direction:row;align-items:center" title=""><i style="font-size:18px;padding-right:5px" class="icon dx-icon-exportselected"></i>' +
                                `${data["text"]}</span>`;

                        return element;
                    },

                    onItemClick: function (e) {
                        //////console.log(e);

                        if (e.itemData["value"] === 1) {
                            //console.warn(that.api);
                            //console.warn(that.apiDettagli);
                            //console.warn(that.appService)
                            that.stampaFile();
                        } else {
                            that.stampaFileRigheSelezionate();
                        }
                    },
                },
            });
        }

        /*
    if(this.idCategoriaModello && this.idCategoriaModello.length>0){
        e.toolbarOptions.items.unshift(
        {
            location: 'after',
            widget: 'dxButton',//'dxDropDownButton',
            //cssClass:'container',
            options: {
                icon: 'exportpdf',
                showArrowIcon: false,
                displayExpr: 'text',
                keyExpr: 'value',
                //itemTemplate:'elementi',
                cssClass: 'tastoExportGriglia',
                elementAttr: { title: 'Esporta a partire dai modelli di stampa' },
                //stylingMode: 'text',
                //useSelectMode:true,
                onClick: () => {
                    this.mostraPopupModelliCaricati = true;
                },
              
            }
        });


    }
    */

        if (this.allowedAdvancedFilter) {
            e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton", //'dxDropDownButton',
                //cssClass:'container',
                options: {
                    icon: "export icon-remove-filter", //devextreme: 'remove', fontello: 'export icon-cancel-circled-1'
                    showArrowIcon: false,
                    displayExpr: "text",
                    keyExpr: "value",
                    //text:'Rimuovi Filtri',
                    //itemTemplate:'elementi',
                    cssClass: "popupFiltri dx-toolbar-text-auto-hide",
                    elementAttr: {
                        title: "Rimuovi Filtri",
                        class: "iconeToolbar",
                    },
                    //stylingMode: 'text',
                    //useSelectMode:true,
                    onClick: () => {
                        //this.optionalBottoneToolbar.emit('popupFiltri');//this.pulsantiOpzionali.indexOf(bottone)
                        //this.filter='';

                        this.onAllEvent.emit("resettaFiltro");
                        this.optionalBottoneToolbar.emit("resettaFiltro");

                        return;
                    },
                },
            });

            e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton", //'dxDropDownButton',
                cssClass: "filtroNonPassato",
                options: {
                    icon: "export icon-filter", //devextreme: 'filter', glyphicon mdi mdi-filter-outline
                    showArrowIcon: false,
                    displayExpr: "text",
                    keyExpr: "value",
                    //itemTemplate:'elementi',
                    cssClass: "popupFiltri",
                    elementAttr: {
                        title: "Filtri Avanzati",
                        id: "bottoneFiltroToolbar",
                        class: "iconeToolbar",
                    },
                    //stylingMode: 'text',
                    //useSelectMode:true,
                    onClick: () => {
                        //this.optionalBottoneToolbar.emit('popupFiltri');/// this.pulsantiOpzionali.indexOf(bottone)
                        //this.pannelloFiltriAvanzati=true;

                        this.onAllEvent.emit("pannelloFiltriAvanzatiVisibile");
                        this.optionalBottoneToolbar.emit(
                            "pannelloFiltriAvanzatiVisibile"
                        );

                        return;
                    },
                },
            });
        }

        //---------------------------
        ////////console.log("Ecco la toolbar ",e.toolbarOptions.items);
        /*e.toolbarOptions.items.push({
          
        location: "before",
        widget: 'dxTextBox',
        cssClass:"long-title", 
        options: {
                text:this.titolo, 
                readOnly:true                    
        }
  
    });*/

        if (this.buttonNavigation && this.buttonNavigation.length > 999999990) {
            for (let bottone of this.buttonNavigation) {
                e.toolbarOptions.items.push({
                    location: "before",
                    widget: "dxButton",
                    cssClass: "buttonNavigation",
                    options: {
                        onClick: () => {
                            this.optionalBottoneNavigation.emit(bottone["id"]); //this.pulsantiOpzionali.indexOf(bottone)
                        },
                        //hoverStateEnabled: false,
                        items: "left",
                        text: bottone["text"],
                        width: 125,
                        stylingMode: "text",
                        useSelectMode: false,
                        //onSelectionChanged: onAlignmentChanged
                    },
                });
            }
        }

        //-------------------------
        if (this.pulsantiOpzionali && this.pulsantiOpzionali.length > 0) {
            for (let bottone of this.pulsantiOpzionali) {
                e.toolbarOptions.items.push({
                    location: bottone.location,
                    widget: bottone.widget ? bottone.widget : "dxButton",
                    cssClass: "myClass" + " " + bottone.cssClass,
                    template: bottone.isTemplateText
                        ? (tmp) => {
                            if (bottone.isTemplateText) {
                                return (
                                    '<span class="fw-normal ms-2">' +
                                    bottone.options.text +
                                    "</span>"
                                );
                            }
                        }
                        : null,
                    options: {
                        icon: bottone.options.icon,
                        text: bottone.options.text,
                        stylingMode: bottone.options.stylingMode,
                        elementAttr: {
                            id: bottone.options.id,
                            title: bottone.options.title,
                            class: bottone.options.class,
                        },
                        disabled: bottone.options.disabled
                            ? bottone.options.disabled
                            : false,
                        visible:
                            bottone.options.visible !== undefined
                                ? bottone.options.visible
                                : true,
                        onClick: (e) => {
                            let allElm =
                                document.querySelectorAll(".dx-state-selected");

                            allElm.forEach((el) => {
                                el.classList.remove("dx-state-selected");
                            });

                            /* 
                if(e.element.classList.contains('dx-state-selected')){
                    e.element.classList.remove('dx-state-selected')
                } */

                            e.element.classList.add("dx-state-selected");

                            let result =
                                this.pulsantiOpzionali.indexOf(bottone);
                            if (bottone.options.index != undefined)
                                result = bottone.options.index;
                            this.optionalBottoneToolbar.emit(result); //this.pulsantiOpzionali.indexOf(bottone)
                        },
                    },
                });
            }
        }
        e.name = "preparaToolbar";
        e.componentName = this.name;
        this.onAllEvent.emit(e);
    }

    resetFilter() {
        this.griglia.instance.clearFilter()
    }

    onCellClick(e) {
        this.onAllEvent.emit(e);
    }
    async onChiusuraFiltroPopup(evt) {
        this.pannelloFiltriAvanzati = false;

        await this.nicaFiltro.annullaFiltro();
    }

    stampaFileRigheSelezionate(isDocx?: boolean) {
        this.areRigheSelezionate = true;

        this.stampaFile(isDocx);
    }

    async stampaFile(isDocx?: boolean) {
        let righe: any[] = [];

        const quello = this;

        if (this.isDataStatic === true) {
            righe = this.griglia.instance.getVisibleRows();

            let myRighe = [];
            righe.forEach((riga) => {
                myRighe.push(riga["data"]);
            });
            this.CostruisciFileJSON(myRighe, isDocx);
        } else {
            //TUTTE LE RIGHE CON EVENTUALI FILTRI

            let filter = this.griglia.instance.getCombinedFilter(true);
            //let dataSourceGriglia = this.griglia.instance.getDataSource();

            //if(this.remoteOperations == true){ //Esempi: Comuni, CER

            let dati: any;

            let getSortedColumns = (): any[] => {
                const instance = this.griglia.instance;
                const allColumns = Array.from(
                    Array(instance.columnCount()).keys()
                ).map((index) => instance.columnOption(index));

                ////console.log(allColumns);

                return allColumns.filter(
                    (col) =>
                        col.sortOrder != null &&
                        col.sortOrder != undefined &&
                        col.sortOrder.length > 0
                );
            };

            //console.warn(getSortedColumns());

            let colonneOrdinate: any[] = getSortedColumns();

            if (colonneOrdinate.length > 0) {
                /*
            dati.sort(
                (a,b)=>(a[`${colonnaOrdinata.dataField}`] > b[`${colonnaOrdinata.dataField}`]) ? 1 : (b[`${colonnaOrdinata.dataField}`] > a[`${colonnaOrdinata.dataField}`]) ? -1 : 0
              
                );
                */
                let queryStringOrderBy = "";

                for (let colonnaOrdinata of colonneOrdinate) {
                    queryStringOrderBy +=
                        colonnaOrdinata.dataField +
                        " " +
                        colonnaOrdinata.sortOrder +
                        ",";
                }

                queryStringOrderBy = queryStringOrderBy.slice(0, -1);

                if (queryStringOrderBy.toLowerCase().includes("lista"))
                    dati = await this.http
                        .get<any>(
                            environment.BASE_API_URL.concat(
                                this.api + (this.filter ? this.filter : "")
                            )
                        )
                        .toPromise();
                else
                    dati = await this.http
                        .get<any>(
                            environment.BASE_API_URL.concat(
                                this.api +
                                (this.filter ? this.filter : "") +
                                (this.filter.includes("?")
                                    ? `$rderby=${queryStringOrderBy}`
                                    : `?$orderby=${queryStringOrderBy}`)
                            )
                        )
                        .toPromise();
                //console.warn(dati)
            } else {
                console.warn(this.api, this.filter, this.filterDettagli);

                dati = await this.http
                    .get<any>(
                        environment.BASE_API_URL.concat(
                            this.api.concat(this.filter)
                        )
                    )
                    .toPromise();
            }

            //console.warn(colonneOrdinate);

            let dataSource: DataSource = new DataSource(
                dati.items ? dati.items : dati
            );

            //dataSource.filter(filter);

            ////console.log(dataSource);
            if (
                this.api.toLowerCase() != "account" &&
                this.utenteSerivce.DammiTipoUtente() != 1
            )
                if (this.isStatic == true) {
                    this.CostruisciFileJSON(this.myDsStatic, isDocx);
                } else
                    dataSource
                        .store()
                        .load({
                            filter: filter,
                        })
                        .done((data) => {
                            //console.warn('Dati da Chiamata',data);

                            this.CostruisciFileJSON(data, isDocx);
                        });
            else
                this.griglia.instance
                    .getDataSource()
                    .store()
                    .load({
                        filter: filter,
                    })
                    .done((data) => {
                        //console.warn('getUserInfo',data);

                        this.CostruisciFileJSON(data.data, isDocx);
                    });
            /*
         else{
 
             this.http.get<any>( environment.BASE_API_URL.concat(this.api)+this.filter, {}).toPromise().then(dataR=>{
                 //console.log("rrrrrrrrrrrrrrrrrrrrr ",dataR)
                 CostruisciPDFJSON(dataR);
             })
             return;
             let dataSource : DataSource= this.griglia.instance.getDataSource();
 
             //console.log("eeeee ",this.griglia.instance)
 
             dataSource.load().then(
                 (data)=>{
                 
                     let dataSource:DataSource = new DataSource(data);
                     ////console.log('data:',data);
 
                     dataSource.filter(filter);
                     ////console.log('datasource:',dataSource);
 
                     dataSource.load().then(
                         (dataFiltrata)=>{
                             CostruisciFileJSON(dataFiltrata);
                         }
                 )
             }
         );
 
         }*/

            //  VECCHIO METODO CON FILTRI NON PIU' FUNZIONANTI
            /*
         (this.griglia.instance.getDataSource().store().load({
                 filter:filter
         }).done(
                 (obj) => {
 
                         (obj.data);
 
                 }
         ));
 
 
         OPPURE
 
         
         */
        }
    }

    async CostruisciFileJSON(righe: any[], isDocx?: boolean) {
        let json: AutoTablePDFConfig = new AutoTablePDFConfig();
        const moment = require("moment");

        if (this.titolo && this.titolo.length > 0)
            json.Page.title = `${this.titolo[0]
                .toUpperCase()
                .concat(this.titolo.substring(1, this.titolo.length))}`;
        else if (this.name && this.name.length > 0) {
            json.Page.title = `${this.name[0]
                .toUpperCase()
                .concat(this.name.substring(1, this.name.length))}`;
        }

        json.Page.title = json.Page.title.replace(/[$]/g, "");

        json.Page.orientamento = this.orientamento ? this.orientamento : "l";
        json.Page.formato = "a4";

        json.Headers = [];

        json.HeaderPage.push({
            text: "$title",
            align: "c",
        });

        json.HeaderPage.push({
            text: `Anno ${new Date().getFullYear()}`,
            align: "r",
        });

        json.HeaderPage.push({
            text: "$descr_licenza",
            align: "l",
        });

        json.FooterPage.push({
            text: "$userName",
            align: "l",
        });
        json.FooterPage.push({
            text: "Pag. $pageNumber di $totalPages",
            align: "r",
        });
        json.FooterPage.push({
            text: "$date  $time",
            align: "c",
        });

        let lookups: any[] = [];

        ////////console.log(righe);

        ////console.log(this.griglia.columns);

        for (let colonna of this.griglia.columns) {
            if (colonna["lookup"] as any) {
                lookups.push(colonna);
            }
        }

        //Costruzione colonne
        for (let colonna of this.griglia.instance.getVisibleColumns()) {
            if (colonna.dataField && colonna.type !== "buttons") {
                json.Headers.push({
                    field: colonna.dataField,
                    caption:
                        colonna.caption.toLowerCase() == "invito"
                            ? "Iscrizione"
                            : colonna.caption,
                    align: colonna.alignment ? colonna.alignment : "left",
                    width: colonna.width
                        ? (colonna.width as number)
                        : undefined,
                });
            }
        }

        //Controllo che vi siano colonne relazionate
        //console.warn(this.api);
        /*
    let templateUsato: any[] = this.dati.getService(this.api);

    if (templateUsato) {

        ////console.log(templateUsato);

        for (let obj of templateUsato) {


            if (!obj.itemType)
                continue;

            if (obj.itemType.toLowerCase() === 'camporelazionato') {

                json.Headers.push({
                    field: obj.placeHolder,
                    caption: obj.caption,
                    align: 'c',
                    isRelated: true,
                    api: obj.apiRelazionale,
                    display: obj.displayRelazionale,
                    width:
                })
            }
        }
    }
    */
        let httpNoInterceptor: HttpClient = new HttpClient(this.httpBackend);

        let token: string = this.utenteSerivce.DammiToken();

        for (let riga of righe) {
            ////console.log('RIGA',riga);

            let temp = {};

            for (let entry of Object.entries(riga)) {
                if (riga[`${entry[0]}`]) {
                    if (
                        moment(
                            riga[`${entry[0]}`].toString().split("T")[0],
                            "YYYY-MM-DD",
                            true
                        ).isValid()
                    ) {
                        let dd = (entry[1] as string)
                            .split("T")[0]
                            .split("-")[2];
                        let mm = (entry[1] as string)
                            .split("T")[0]
                            .split("-")[1];
                        let yyyy = (entry[1] as string)
                            .split("T")[0]
                            .split("-")[0];

                        temp[entry[0]] = `${dd}/${mm}/${yyyy}`;
                    } else {
                        /*
            if(entry[0].toLowerCase() == 'invito') //Nel caso di anagrafica utenti
                temp['iscrizione'] = entry[1];
            else
            */

                        temp[entry[0]] = entry[1];
                    }
                }

                for (let colonna of json.Headers) {
                    if (
                        colonna.isRelated == true &&
                        entry[0] == colonna.field &&
                        entry[1]
                    ) {
                        let ris: any = await httpNoInterceptor
                            .get<any>(
                                environment.BASE_API_URL.concat(
                                    colonna.api.replace("$", entry[1] as string)
                                ),
                                {
                                    headers: {
                                        Authorization: "Bearer " + token,
                                    },
                                }
                            )
                            .toPromise();

                        ////console.log(ris);

                        for (let dis of colonna.display) {
                            temp[colonna.field] += ris[`${dis}`] + " ";
                        }
                    }
                }
            }

            json.Rows.push(temp);
        }

        ////console.log(json);

        //Il lookup (in DevExtreme ma anche in altri contesti) è come la select, a video vedo una displayExpr ma in realtà il vero valre è contenuto nella valueExpr
        //il dataSource di un lookup che può essere o realizzato all'interno del codice (es. tipoUtente) oppure ottenuto
        //da una chiamata all'api (es. siglaProvincia)

        if (lookups) {
            for (let lookup of lookups) {
                //Questi sono i lookups dalla griglia

                const displayExpr: string = lookup.lookup["displayExpr"]
                    ? lookup.lookup["displayExpr"]
                    : lookup["displayExpr"]; //Quello che vedo a video es. descrizione="Administrator"
                const valueExpr: string = lookup.lookup["valueExpr"]
                    ? lookup.lookup["valueExpr"]
                    : lookup["valueExpr"]; //Il valore effettivo es. id=3

                if (!lookup.lookup["dataSource"]) continue;

                let dataSource: any[] = lookup.lookup["dataSource"]["store"]
                    ? lookup.lookup["dataSource"]["store"]["__rawData"]
                    : lookup.lookup["dataSource"]; //I Valori di questo lookup es. { id:3, descrizione:"Administrator"}

                /*
            if(lookup.lookup["dataSource"]["store"])
                console.warn(lookup.lookup["dataSource"]["store"]["__rawData"]);
        */

                for (let riga of json.Rows) {
                    if (riga[lookup.name]) {
                        //tipoUtente:3 ora devo sostituire il valueExpr (id:3) con il valore del displayExpr(descrizione:"Administrator")

                        for (let dato of dataSource) {
                            if (!dato) break;

                            if (dato[valueExpr] === riga[lookup.name]) {
                                riga[lookup.name] = dato[displayExpr];

                                break;
                            }
                        }
                    }
                }
            }
        }

        //console.warn(json);

        //Se sto scaricando il docx
        if (isDocx == true) {
            this.docxExporterService.realizzaDocumento(json);

            return;
        }

        //let jsonString = JSON.stringify(json);

        ////console.log(jsonString);

        this.popupAnteprimaPDFVisible = true;

        await this.modelliStampaService.generaPDFAutoTable(
            json,
            this.titolo,
            "preview"
        );

        /*
        VECCHIA PROCEDURA
    const factory = this.componentFactoryResolver.resolveComponentFactory(AnteprimaPDfComponent);
    setTimeout(() => {
        this.dynamicInsert.clear();
        let hInstance = this.dynamicInsert.createComponent(factory, 0);
        hInstance.instance.isCreatedThroughTemplate = false;
        hInstance.instance.jsonDaEsterno = jsonString;
        hInstance.instance.mostraDati(jsonString);

        let evento={}
        evento['name'] = "onShowPDF";
        evento['componentName'] = this.name;
        this.onAllEvent.emit(evento);

        //hInstance.instance.lookups = lookups;

        hInstance.instance.emettiChiusura.subscribe(
            (val) => {

                if (val) {
                    this.dynamicInsert.clear();
                    this.popupAnteprimaPDFVisible = false;
                }

            }
        )

    }, 500);
    */
    }

    chiudiPopup(e: any) {
        this.dynamicInsert.clear();

        this.popupAnteprimaPDFVisible = false;
    }

    async gestisciEventoExcelExporter(evt) {
        if (!evt) {
            this.pannelloEsportaExcelAdvanced = false;

            return;
        } else {
            ////console.log(evt);

            if (evt.colonnaDaOrdinare) {
                this.colonneDaEsportare = evt.ris;

                await this.esportaXls(this.griglia.instance, false);
            } else {
                this.colonneDaEsportare = evt;

                await this.esportaXls(this.griglia.instance, false);
            }
        }
        ////console.log(evt);
    }

    async esportaXls(component: dxDataGrid, selectedRowsOnly: boolean = false) {
        // evt.cancel = true;

        let that = this;

        /*
     //Volevo create una copia dell'event 'evt', ma dato che al suo interno ci sono metodi oltre che proprietà non è possibile
     //con i metodi già presenti per creare cloni oggetto
 
 
 
     ////console.log(this.colonneDaEsportare);
 
 
     let templateUsato: AnaColumn[] = this.dati.getService(this.service);
 
     //let dataGridTemp : DxDataGridComponent = new DxDataGridComponent();
 
     //dataGridTemp.
 
 
     let httpNoInterceptor: HttpClient = new HttpClient(this.httpBackend);
 
     let token: string = this.utenteSerivce.DammiToken();
 
 
     let filter = this.griglia.instance.getCombinedFilter(true);
     //let dataSourceGriglia = this.griglia.instance.getDataSource();
 
     let dati: any;
     let datiFixed: any[] = [];
 
 
     let getSortedColumns = (): any[] => {
         const instance = this.griglia.instance;
         const allColumns = Array.from(Array(instance.columnCount()).keys()).map(index => instance.columnOption(index));
 
 
         return allColumns.filter(col => col.sortOrder != null && col.sortOrder != undefined);
     }
 
 
 
 
 
 
     let colonneOrdinate: any[] = getSortedColumns();
 
 
     
         dati = await this.http.get<any>(environment.BASE_API_URL.concat(this.api.concat(this.filter))).toPromise();
     
         if(!dati)
             return;
             
 
     let dataSource: DataSource = new DataSource(dati.items ? dati.items : dati);
 
 
 
     dataSource.store().load({
         filter: filter
     }).done(
         async (data:any) => {
 
          
             
             
         });
     */

        const ExcelJS = require("exceljs");

        const workbook = new ExcelJS.Workbook();

        let filename =
            that.titolo && that.titolo.length > 0
                ? that.titolo
                : that.titoloPopUp && that.titoloPopUp.length > 0
                    ? that.titoloPopUp
                    : that.popupComponentTitle &&
                        that.popupComponentTitle.length > 0
                        ? that.popupComponentTitle
                        : that.name;

        filename = filename.replace(/[*?:\\/[\]]/g, "");

        const worksheet = workbook.addWorksheet(filename);

        exportDataGrid({
            component,
            worksheet,
            autoFilterEnabled: true,
            keepColumnWidths: true,
            selectedRowsOnly: false, //Se in Nica Anagrafica esistesse la selezione/deselezione della riga con la spunta si potrevve togliere il "false"
            customizeCell: async (options) => {
                options.excelCell.alignment = { horizontal: "left" };

                if (options.gridCell.rowType == "header") {
                    options.excelCell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "fffbd6" },
                    };
                    options.excelCell.font = {
                        color: { argb: "8b0000" },
                        underline: false,
                    };
                }

                //controllo se il carattere § è presente nel valore della cella
                if (
                    worksheet.getCell(options.excelCell["_address"]).value &&
                    worksheet
                        .getCell(options.excelCell["_address"])
                        .value.toString()
                        .includes("§")
                ) {
                    worksheet.getCell(options.excelCell["_address"]).value =
                        worksheet
                            .getCell(options.excelCell["_address"])
                            .value.replaceAll("§", "");
                }

                //controllo se il carattere | è presente nel valore della cella
                if (
                    worksheet.getCell(options.excelCell["_address"]).value &&
                    worksheet
                        .getCell(options.excelCell["_address"])
                        .value.toString()
                        .includes("|")
                ) {
                    worksheet.getCell(options.excelCell["_address"]).value =
                        worksheet
                            .getCell(options.excelCell["_address"])
                            .value.replaceAll("|", "");
                }

                if (
                    typeof options.gridCell.value === "boolean" &&
                    !options.gridCell.value
                ) {
                    //options.gridCell.column.name
                    //////console.log('gridCell',options.gridCell);
                    //////console.log('excelCel',options.excelCell);

                    worksheet.getCell(options.excelCell["_address"]).value =
                        "No";
                } else if (
                    typeof options.gridCell.value === "boolean" &&
                    options.gridCell.value
                ) {
                    worksheet.getCell(options.excelCell["_address"]).value =
                        "Si";
                }

                if (options.gridCell.column.dataField == "guidAccettazione") {
                    if (
                        worksheet
                            .getCell(options.excelCell["_address"])
                            .value.toLowerCase() == "invito"
                    )
                        worksheet.getCell(options.excelCell["_address"]).value =
                            "Iscrizione";
                    else if (
                        worksheet.getCell(options.excelCell["_address"]).value
                            .length > 0
                    )
                        worksheet.getCell(options.excelCell["_address"]).value =
                            "In Attesa";
                    else
                        worksheet.getCell(options.excelCell["_address"]).value =
                            "Confermata";
                }

                if (
                    options.gridCell.column.dataField == "tipoAttivita" &&
                    options.gridCell.data !== undefined
                ) {
                    let attivitaSvolte = "";

                    let tipoAttivitaObj = options.gridCell.data;

                    if (
                        tipoAttivitaObj["isProduttore"] == true ||
                        tipoAttivitaObj["is_produttore"] == true
                    )
                        attivitaSvolte += "P ";

                    if (
                        tipoAttivitaObj["isTrasportatore"] == true ||
                        tipoAttivitaObj["is_trasportatore"] == true
                    )
                        attivitaSvolte += "T ";

                    if (
                        tipoAttivitaObj["isDestinatarioRifiuto"] == true ||
                        tipoAttivitaObj["is_smaltitore"] == true
                    )
                        attivitaSvolte += "D ";

                    if (
                        tipoAttivitaObj["isIntermediario"] == true ||
                        tipoAttivitaObj["is_intermediario"] == true
                    )
                        attivitaSvolte += "I ";

                    attivitaSvolte = attivitaSvolte.trim().replace(/[ ]/g, "-");

                    worksheet.getCell(options.excelCell["_address"]).value =
                        attivitaSvolte;
                }

                //Qui dovrò effettuare la trasformazione dei lookups in devExtreme e sostituirne i valori

                if (options.gridCell.column.lookup) {
                    let lookups: any[] = options.gridCell.column.lookup
                        .dataSource as any[];

                    const displayExpr =
                        options.gridCell.column.lookup.displayExpr;
                    const valueExpr = options.gridCell.column.lookup.valueExpr;

                    //////console.log(displayExpr);

                    //////console.log(valueExpr);

                    //console.table(lookups);

                    if (lookups && lookups.length > 0)
                        for (let lookup of lookups) {
                            if (
                                lookup[`${valueExpr}`] ===
                                worksheet.getCell(options.excelCell["_address"])
                                    .value
                            ) {
                                worksheet.getCell(
                                    options.excelCell["_address"]
                                ).value = lookup[`${displayExpr}`];
                            }
                        }
                }
            },
        }).then(() => {
            workbook.xlsx.writeBuffer().then(async (buffer) => {
                filename = filename.replace(/[$]/g, "");
                saveAs(
                    new Blob([buffer], { type: "application/octet-stream" }),
                    `${filename}.xlsx`
                );
                setTimeout(() => {
                    that.onEsportatoXls();
                }, 3000);
            });
        });
    }

    onEsportatoXls() {
        this.colonneDaEsportare = undefined;

        this.pannelloEsportaExcelAdvanced = false;
        const e = {
            name: "onEsportatoXls",
            masterComponent: this,
        };
        this.onAllEvent.emit(e);
    }

    OptionalButtonDropDown(e, c) {
        /*
         Emetto all'esterso, cosa?
         1) i dati della rica
         2) le informazione dell'item bottone cliccato
         3) componente Griglia per inserirlo in un servizio
    */
        let emitArray = {
            infoButton: e.itemData,
            datiGriglia: c.data,
            component: c.component,
        };

        this.selezionaRiga(c.row.data[this.masterKey]);
        c.name = e.itemData.value;
        this.mythis.optionalButton.emit(emitArray);
    }

    editorOptionsButtons(campo) {
        if (campo.button) {
            return {
                name: campo.button.name,
                location: campo.button.location,
                options: {
                    stylingMode: "text",
                    icon: campo.button.icon,
                },
            };
        } else return [];
    }
    editorOptionsXX(campo) {
        return {
            classe: campo.classe,
            mask: campo.mask,
            minLength: campo.minLength,
            maxLength: campo.maxLength,
            inputAttr: {
                style: "width:" + campo.width + "px;" + campo.attr,
            },
            //buttons:this.editorOptionsButtons(campo),
        };
    }

    OptionalIconButtoninArrayClick = (e: any, t: any) => {
        let m = {
            name: e,
            row: t,
        };
        this.mythis.optionalButton.emit(m);
        console.log("OptionalIconButtoninArrayClick", e);
        console.log("OptionalIconButtoninArrayClick", t);
    };

    OptionalIconButtonClickNO(e: any) {
        console.log("OptionalIconButtonClickNO ", e);
        if (e.element.attributes.name) {
            console.log(
                "OptionalIconButtonClickNO ",
                e.element.attributes.name
            );
        }

        return;
        e.name = e.column.buttons[0].name;
        this.optionalButton.emit(e);
        //this.onAllEvent.emit(e);
        this.mythis.callbackFunction.emit(e);
        ////////console.log(this.mythis);
        return;

        var oldData = this.mythis.griglia.instance.getDataSource()._items[0];
        var objActual = this.mythis.griglia.instance.getController("editing");
        var actualData = objActual._dataController._items[0]["data"];

        e.event.preventDefault();

        /*
    this.formData = {};
    //const t = this;
    let inputs = document.getElementsByClassName("dx-texteditor-input");
    for(let i = 0 ; i < inputs.length ; i ++){
        if((inputs.item(i) as HTMLInputElement).getAttribute("id") !== null && (inputs.item(i) as HTMLInputElement).getAttribute("id") !== undefined){
            let propRaw = (inputs.item(i) as HTMLInputElement).getAttribute("id").split("_");
            let prop = propRaw[propRaw.length-1];
            let value = (inputs.item(i) as HTMLInputElement).value;
            this.formData[`${prop}`] = `${value}`;
        }
    }
    ////////console.log(this.formData);
    */

        if (!e.element.outerText) {
            return;
        }

        e["name"] = e.element.outerText; //es. "Vedi Mappa"
        e["data"] = actualData; //I valori presenti nella form attuale
    }

    updateEdit(value) {
        //    this.griglia.instance.cellValue(0,'Descrizione','Carmine Napolitano')

        ////////console.log(" in updateEdit ",value);

        return;
        var oldData = this.mythis.griglia.instance.getDataSource()._items[0];
        var objActual = this.mythis.griglia.instance.getController("editing");
        var actualData = objActual._dataController._items[0]["data"];

        objActual._dataController._items[0]["data"]["descrizione"] =
            "wwwwwwwwwwwwwwwwwww";

        ////////console.log("Ecco i valori da aggiornare ",value);
        this.fnInstnce["descrizione"].setValue("Provolino");

        objActual.component.refresh();

        ////////console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwww ",objActual);
    }

    chiudi(e, dropDownBoxComponent) {
        //  e.values[0] = e.selectedRowKeys[0];
        dropDownBoxComponent.close();
    }
    buttonOptionsTest = {
        onClick: function () {
            alert("wwwwwwwwwwwww", "wwwwwwww");
            // ...
        },
    };

    buttonOptions = {
        text: "Send an Email",
        onClick: function () {
            // ...
        },
    };
    keyDown(w: any) {
        // premuto tasto accept_characters
        //alert("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww","wwww");
        if (w.event.keyCode == 112) {
            // F1
            w.event.key = null;
            w.event.stopPropagation();
            w.event.preventDefault();
            return;
        }

        if (w.event.keyCode > 112 && w.event.keyCode < 124) return; // tasti funzionali
        if (w.event.keyCode >= 16 && w.event.keyCode < 20) return; // tasti funzionali

        let keyCodeEsculi = [8, 46, 37, 39, 38, 40, 9];
        if (keyCodeEsculi.includes(w.event.keyCode)) return;

        //Prog=w.event.target.attributes[2]
        let rr1 = Object.entries(w.event.target.attributes);
        let trovato = false;
        for (let t = 0; t < rr1.length; t++) {
            if (
                rr1[t][1]["name"] == "acceptonlycharacters" &&
                rr1[t][1]["value"] > ""
            ) {
                trovato = true;
                if (rr1[t][1]["value"][0] == "/") {
                    let result = rr1[t][1]["value"].substring(
                        1,
                        rr1[t][1]["value"].length - 1
                    );
                    var test = new RegExp(result, "m");
                    var st = "" + w.event.key;
                    let m;
                    if ((m = test.exec(st)) !== null) {
                        /* m.forEach((match, groupIndex) => {
                 console.log(`Found match, group ${groupIndex}: ${match}`);
         });*/
                    }
                    if (!st.match(test)) {
                        w.event.key = null;
                        w.event.preventDefault();
                        return;
                    }
                    continue;
                }
                let KeyAccept = "" + rr1[t][1]["value"];
                if (!KeyAccept.includes(w.event.key)) {
                    w.event.key = null;
                    w.event.preventDefault();
                }
            }
            if (rr1[t][1]["name"] == "patterns" && rr1[t][1]["value"] > "") {
                console.log("Trovato pattern ", w);
            }

            //keyDown
        }
        if (!trovato) {
            if (w.component.NAME == "dxTextBox") {
                let result = environment.GENERIC_STRING;
                result = result.substring(1, result.length - 1);
                var test = new RegExp(result, "m");
                var st = "" + w.event.key;
                if (!st.match(test)) {
                    w.event.key = null;
                    w.event.preventDefault();
                    return true;
                }
            }
        }
        return;

        let rr = Object.values(w.event.target.attributes).find(
            (element) => element["name"] == "accept_characters"
        );
        if (rr) {
            //rr.includes(w.key)
            let gg = JSON.stringify(rr, ["name"]);
            //console.log((rr['accept_characters']));
        }
    }

    AggiornaButtonNavigation(elementi) {
        return;
        this.buttonNavigation = [];
        this.buttonNavigation = elementi;
        setTimeout(() => {
            this.griglia.instance.repaint();
        }, 1);
    }

    onShowing(e) {
        ////////console.log('eventooooo',e);
        e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
        e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
        //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
        e.component.content().classList.add("soggetto-form"); //add class to content
        //e.component.content().classList.add("padding"); //add class to content

        e.component.content().classList.add("paddingEditingForm"); //add class to content
    }

    chiudiPopupEditing() {
        //Anche il Column Chooser ne è influenzato

        this.popupEditVisible = false;

        //(this.griglia.instance as any).hideColumnChooser();

        if (this.griglia) (this.griglia.instance as any).cancelEditData(); //effettua l'annullamento dell'edit, quindi in effetti chiude il popup
    }

    daEsterno(query: string) {
        //alert(query,"da esterno");
    }

    checkLoad(res: any) {
        if (this.dettagliCer > "") {
            res.forEach((element) => {
                this.appService
                    .GetApi("Cer/" + element.cer)
                    .then((response) => {
                        element[this.dettagliCer] = response["descrizione"];
                    });
            });
            return res;
        }
        if (this.tagLoad.toLocaleLowerCase() == "permessi") {
            ////console.log("In Tag Load ",res);
            /* let rr={
         "id": 2,
         "idGruppo": 0,
         "idMenuFunzioni": "043",
         "descrizioneuFunzioni": "Anagrafiche Operatori",
         "macroMenu": "R",
         "inserimento": false,
         "modifica": false,
         "cancellazione": false,
         "visualizzazione": false
 }
     res.funzioni.unshift(rr);*/
            return res.funzioni;
        }
        if (this.tagLoad.toLocaleLowerCase() == "schederifiuti") {
            ////console.log("In Tag Load ",res);
            if (res)
                for (let i = 0; i < res.length; i++) {
                    res[i]["idcer"] = res[i]["cer"];
                }
            return res;
        }
        if (this.tagLoad.toLocaleLowerCase() == "giacenzerifiuti") {
            ////console.log("In Tag Load ",res);
            if (res)
                for (let i = 0; i < res.length; i++) {
                    res[i]["idcer"] = res[i]["cer"];
                }
            return res;
        }
        if (this.tagLoad.toLocaleLowerCase() == "statisticarifiutiNO") {
            ////console.log("In Tag Load ",res);
            if (res)
                for (let i = 0; i < res.length; i++) {
                    //res[i]['cer']=res[i]['cer']+"("+res[i]['descrizioneStatoFisico']+")";
                }
            return res;
        }

        if (this.masterThis.checkGetAll.observers.length > 0) {
            ////console.log("checkGetAll ",res)
            let event = {};
            event["name"] = "checkLoad";
            event["componentName"] = this.name;
            event["data"] = res;
            //this.masterThis.checkGetAll.emit(event)
            let ris = this.masterThis.checkGetAll.emit(event); // deve obbligatoriamente ritornare array records
            ////console.log("checkGetAll ris",ris)
            if (ris) return ris;
            else return res;
        } else return res;
    }

    tabClick(e) {
        console.log("Tab click ", e);
        this.TabbedSelected = e.itemIndex;
    }

    OptionalButtonDropDownInitialized($event, buttons, cella, dropDown) {
        //console.log('eventdropDown',$event)

        const rowData = cella.data;

        const componentMenu = $event.component;
        //console.log(buttons)
        let emitArray = {
            infoButton: "grigliaDropDownButtonInit",
            buttons: buttons,
            data: rowData,
            componentMenu: componentMenu,
            componentDrop: dropDown.component,
            event: $event.event,
        };

        this.optionalButton.emit(emitArray);
    }

    dropDownShow(e) {
        /*   e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
        e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content */
        //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
        //console.log(e)
        e.component.content().classList.add("drop-down-grid"); //add class to content
    }

    customSource(e: any) {
        let myApiLook = environment.BASE_API_URL_APIREST + e.lookup.dataSource;
        if (this.wingap)
            myApiLook = environment.BASE_API_URL + e.lookup.dataSource;
        return new CustomStore({
            loadMode: "processed",
            key: e.lookup.id,
            load: (loadOptions: any) => {
                //************************************************************************ */
                let params: HttpParams = new HttpParams();
                [
                    "skip",
                    "take",
                    "requireTotalCount",
                    "requireGroupCount",
                    "sort",
                    "filter",
                    "totalSummary",
                    "group",
                    "groupSummary",
                    "TipoOperazione",
                ].forEach((i) => {
                    if (i in loadOptions && this.isNotEmpty(loadOptions[i])) {
                        let cVal = JSON.stringify(loadOptions[i]);
                        cVal = cVal.replace(/"/g, "");
                        params = params.set(i, cVal);
                    }
                });
                return this.http
                    .get(myApiLook, { params })
                    .toPromise()
                    .then((res) => {
                        if (res["items"]) {
                            res = res["items"];
                        } else {
                            res = res;
                        }
                        return res;
                    });
            },
        });
    }

    parseInta(x) {
        try {
            return parseInt(x);
        } catch (error) {
            return 0;
        }
    }

    instanceComponent(component) {
        if (this.componentRef) {
            // this.componentRef.destroy()
        }

        const factories = Array.from(
            this._componentFactoryResolver["_factories"].keys()
        );
        const factoryClass = <Type<any>>(
            factories.find((x: any) => x.name === component.nameComponent)
        );

        const componentFactory: ComponentFactory<any> =
            this._componentFactoryResolver.resolveComponentFactory(
                factoryClass
            );
        //console.log("UNOOOOOOOOOOOOOOOOOOO");
        setTimeout(() => {
            //alert("Creoooooooooooooooooo","creoooooooooo")
            if (this.dynamicInsertFormComponent)
                this.dynamicInsertFormComponent.clear();
            this.componentRef = this.dynamicInsertFormComponent.createComponent(
                componentFactory,
                0
            );
            //hInstance.instance.isCreatedThroughTemplate = false;
            //hInstance.instance.jsonDaEsterno = jsonString;
            //hInstance.instance.mostraDati(jsonString);
            //this.componentRef = this.dynamicInsertFormComponent.createComponent(componentFactory);
            // alert(this.currentRow['cer'],"wwwww")
            let valueKey = "";
            if (component.related) {
                valueKey = this.currentRow[component.related[0].dataField];
                ////console.log("PRIMA DUEEEEEEEEEEEEEEEEEE");
            }

            let data = [
                {
                    idTabRif: this.filterKey,
                    component: component,
                    this: this,
                    key: "id",
                    valueKey: valueKey,
                    eventSelect: component.eventComponent,
                    api: component.api,
                    service: component.sevice,
                    name: component.name,
                    //name:component.name
                },
            ];

            //this.componentRef.instance.data = data
            //this.componentRef.instance.inizializza(data);
            // this.instanceComponent=this.componentRef.instance;

            component.instance = this.componentRef.instance;
            component.instance.data = data;
            component.instance.inizializza(data);

            /*if(!this.componentRef.instance.outputEmit) return;
     (this.componentRef.instance.outputEmit as EventEmitter<any>).subscribe(
         (res) => {
             let rowInEdit;
             let rows = this.griglia.instance.getVisibleRows();
             let Index = -1;
             rows.forEach(row => {
                 Index++;
                 if (row.isSelected || row.isEditing || row.isNewRow) {
                     this.griglia.instance.cellValue(Index,res.related, res.valueKey)
                 }
             })
         })*/
        }, 500);
    }

    pulsanteCaricaModello = {
        text: "Scarica",
        type: "normal",
        icon: "download",
        onClick: async () => {
            if (
                this.datagridModelliStampa.instance.getSelectedRowKeys()[0][
                "id"
                ]
            ) {
                await this.spinner.show();

                let modelloDiStampaCaricato =
                    await this.modelliStampaService.getModelloById(
                        parseInt(
                            this.datagridModelliStampa.instance.getSelectedRowKeys()[0][
                            "id"
                            ]
                        )
                    );

                //const factory = this.componentFactoryResolver.resolveComponentFactory(NicaModelloStampaComponent);
                await this.modelliStampaComp.caricaModello(
                    modelloDiStampaCaricato.id
                );

                setTimeout(async () => {
                    //let hInstance = this.modellatoreDinamico.createComponent(factory, 0);
                    //hInstance.instance.modelloDiStampaCaricato = modelloDiStampaCaricato;

                    //console.warn(modelloDiStampaCaricato);
                    /*
         if(this.filter && this.filter.length>0)
             hInstance.instance.ODataQueryString = this.filter; Scommentare righe quando funzionerà
         */

                    //await hInstance.instance.caricaModello(modelloDiStampaCaricato.id);

                    await this.modelliStampaComp.onClickGeneraPDF();

                    this.mostraPopupModelliCaricati = false;

                    await this.spinner.hide();

                    //hInstance.instance.lookups = lookups;
                }, 500);

                //this.caricaModello(this.datagridModelliStampa.instance.getSelectedRowKeys()[0]['id']);
            }
        },
    };

    onChiusuraPopupModelliStampa(evt) {
        this.mostraPopupModelliCaricati = false;
    }
    /*
 rimuoviFiltro(evt){


     this.filter = "";
     console.warn('sto inserendo filtro',evt);

 }
*/
    displayExprFunct(dataField, displayExpr, data) {
        //console.log('dataField',dataField)
        //console.log('displayExpr',displayExpr)
        //console.log('data',data);

        if (Array.isArray(displayExpr)) {
            let string = "";

            displayExpr.forEach((display) => {
                if (typeof data.displayValue[display] != "undefined") {
                    string += data.displayValue[display] + " ";
                }
            });
            //console.log(string)
            return string;
        } else {
            return data["displayValue"];
        }
    }

    innerHtmlFunction(e) {
        let html = "";

        if (Array.isArray(e)) {
            e.forEach((dato) => {
                html +=
                    '<span class="badge ' +
                    dato.class +
                    ' rounded-pill ms-auto">' +
                    dato.value +
                    "</span>";
            });
        } else {
            html += '<small class="badge">' + e + " - </small>";
        }

        return html;
    }

    onFocusedRowChanging(e) {
        return;
        //alert("onFocusedRowChanging","onFocusedRowChanging")
        const rowsCount = e.component.getVisibleRows().length;
        const pageCount = e.component.pageCount();
        const pageIndex = e.component.pageIndex();
        const key = e.event && e.event.key;

        if (key && e.prevRowIndex === e.newRowIndex) {
            if (e.newRowIndex === rowsCount - 1 && pageIndex < pageCount - 1) {
                e.component.pageIndex(pageIndex + 1).done(() => {
                    e.component.option("focusedRowIndex", 0);
                });
            } else if (e.newRowIndex === 0 && pageIndex > 0) {
                e.component.pageIndex(pageIndex - 1).done(() => {
                    e.component.option("focusedRowIndex", rowsCount - 1);
                });
            }
        }
    }

    onFocusedRowChanged(e) {
        e.component.selectRowsByIndexes([e.rowIndex]);
        return;
        //console.log("onFocusedRowChanged ",e)
        //alert("ci sono ","cis ono")
        return;
        //alert(var currentKey = selKey[0];
        e.component.selectRows([e.row.data.key], true);
        e.component.option("focusedRowIndex", e.rowIndex);

        return;
        //console.log("onFocusedRowChanged ",e)
        //console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq ",e.component)
        //this.onRowSelect.emit(e.row.data);
        //return;
        const rowData = e.row && e.row.data;
        if (rowData) {
            e.component.selectRows([e.row.data.key], true);
            e.component.option("focusedRowIndex", e.rowIndex);

            let event = {
                name: "onFocusedRowChanged",
                componentName: this.name,
                data: e.row.data,
            };
            // this.onAllEvent.emit(event);
            this.onRowSelect.emit(event.data);
        }
    }

    clikkatoSuGruppo(data) {
        alert("clikkato su gruppo ", "edit");
    }
    printValue(e, colonna) {
        //console.log("Ecco Dataaaa ",e)
        return e.value;
        let rec;
        if (e.data.collapsedItems) {
            rec = e.data.collapsedItems[0];
        }
        if (e.data.items) {
            rec = e.data.items[0];
        }
        return (
            rec.sD_RagioneSociale +
            " - " +
            rec.sD_Indirizzo +
            " - " +
            rec.sD_Comune
        );
    }
    printValueDynamic(e, colonna) {
        console.log("Ecco Dataaaa ", e);
        console.log("Ecco Dataaaa colonna", colonna);

        if (Array.isArray(e.value)) {
            let displayExpr = colonna.dynamic.displayExpr
                ? colonna.dynamic.displayExpr
                : colonna.dynamic.valueExpr;
            return e.value.filter((ress) => ress[displayExpr]);
        }
    }
    DammiDetailKey(masterDetailItem) {
        // console.log("Ecco il dettaglio ",masterDetailItem);
        // this.mythis.callbackFunction.emit(masterDetailItem) ;
        return masterDetailItem.key;
    }
    onRowExpanding(e) {
        this.griglia.instance.collapseAll(-1);
        //  $(".evidenzia .employee").removeClass("employee")
        if (e.key) this.keyEspansa = e.key;
        // console.log("Ecco ESPANZIONE ",e)

        //  $("[ng-reflect-name='"+this.name+"'] ."+this.classEvidenziaMaster+"").removeClass(this.classEvidenziaMaster)

        e.name = "onRowExpanding";
        e.masterComponent = this;
        e.childrenGrid = this.masterDetailGrid;

        this.onAllEvent.emit(e);
    }
    getRadioButton(e) {
        // return null;//e.radioGroup.items;
    }
    getTestoDaVisualizzare(e, colonna) {
        const found = this.dsLookups[colonna.prog].find((element) => {
            return element[colonna.radioGroup.valueExpr] === e.value;
        });
        if (found) return found[colonna.radioGroup.displayExpr];
    }
    onFocusedCellChanging(ev) {
        console.log("wwwwwwwwwwwwwwwwww ", ev);
        if (ev.newRowIndex == ev.vprevRowIndex) {
            //ev.event.code=='ArrowLeft'
            //ev.cancel=true;
            //return;
        }
        if (this.modeEdit == "row") {
            if (this.chiaviDettagli) {
                if (ev.event.code == "ArrowRight") {
                    ev.component.collapseAll(-1);
                    ev.component.expandRow(ev.newRowIndex);
                }
            }
            if (
                ev.event &&
                (ev.event.code == "ArrowLeft" || ev.event.code == "ArrowRight")
            ) {
                ev.event.keyCode = 0;
                ev.cancel = true;
                ev.isHighlighted = false;
                ev.event.preventDefault();
            }
        }
        //ev.event.isHighlighted=false;
    }
    onSelectionChangedTab(ev) {
        console.log("tabssssssssssssssss ", ev);
    }

    onPannelloGestioneStruttureEvent(evt) {
        if (evt == undefined) {
            this.pannelloEsportaExcelAdvanced = false;
        }
    }
    checkBoxHeader(e) {
        alert("cambiato", "check");
        console.log(e);
    }
    inizializzato(e) {
        console.log("inizializzato ", e);
    }
    chiudiDxDropBoxDown(e, colonna) {
        let GridComponent = this.name_lookup.toArray();
        console.log("GridComponent", GridComponent);
        let myComponent = null;
        console.log("alerts ", this.alerts);
        GridComponent.forEach((elemento) => {
            console.log("ELEMENTO  ", elemento);
            console.log("ELEMENTIIIIIIIIIIIIIIIII ", elemento);
            if (elemento.name == "lookup_" + colonna.dataField)
                elemento.instance.close();
        });
        setTimeout(() => {
            // this.name_lookup_pippo.instance.close();
            //myComponent.instance.close();
        }, 200);
        //  if (myComponent) myComponent.close();

        //$("#pipparolo").trigger("click");
    }

    // Metodo per caricare lo stato
    loadGridState() {
        //alert("Lod", "loadstate")
        return;
        const state = sessionStorage.getItem(this.gridStateKey);
        return state ? JSON.parse(state) : null;
    }

    // Metodo per salvare lo stato
    saveGridState(state: any) {
        return;
        sessionStorage.setItem(this.gridStateKey, JSON.stringify(state));
    }
    onCustomizeColumns(columns: Column[]): void {
        return;
        if (!this.prefix) return;
        columns.forEach(col => {
            // preserva qualsiasi comportamento predefinito
            let defaultCalcFilter: any;
            if (col.calculateFilterExpression) {
                defaultCalcFilter = col.calculateFilterExpression.bind(col);
            }



            col.calculateFilterExpression = function (filterValue, selectedFilterOperation, target) {
                if (!filterValue) {
                    return defaultCalcFilter
                        ? defaultCalcFilter(filterValue, selectedFilterOperation, target)
                        : undefined;
                }

                // sostituisci 'm.' + dataField nel filtro
                const fullField = `${this.prefix}.${this.dataField}`;
                return [fullField, selectedFilterOperation, filterValue];
            };
        });
    }
}
